<template>
    <div>
        <template>
            <rkm-form
                ref="form"
                v-if="model && form"
            >
                <rkm-alert color="info">
                    Os paciente com saída do cadastro por motivo de óbito ou mudança de território não serão exibidos.
                </rkm-alert>
                <rkm-row>
                    <rkm-col>
                        <rkm-area
                            title="Filtros"
                            type="fieldset"
                        >
                            <rkm-row>
                                <rkm-col>
                                    <rkm-area
                                        title="Equipe"
                                        type="fieldset"
                                    >
                                        <template slot="trailing">
                                            <rkm-button
                                                @click="visibleEquipe = !visibleEquipe"
                                                color="primary"
                                                small
                                            >
                                                <rkm-icon :icon="visibleEquipe ? 'angle-double-up' : 'angle-double-down'" />
                                            </rkm-button>
                                        </template>

                                        <rkm-collapse :visible="visibleEquipe">
                                            <rkm-row>
                                                <rkm-col cols="5">
                                                    <rkm-form-select
                                                        :disabled="!additionals.isSecretariaType"
                                                        :options="form.unidadeEquipe"
                                                        :validations="validations.unidadeEquipeId"
                                                        @change="changeUnidadeEquipe"
                                                        default-option-text="Selecione"
                                                        label="Unidade"
                                                        show-default-option
                                                        text-field="nomeFantasia"
                                                        v-model="model.unidadeEquipeId"
                                                        value-field="id"
                                                    />
                                                </rkm-col>

                                                <rkm-col cols="5">
                                                    <rkm-form-select
                                                        :options="form.infraestruturaEquipe"
                                                        :validations="validations.infraestruturaEquipeId"
                                                        @change="changeInfraestruturaEquipe"
                                                        default-option-text="Selecione"
                                                        label="Local de atendimento"
                                                        show-default-option
                                                        text-field="nome"
                                                        v-model="model.infraestruturaEquipeId"
                                                        value-field="id"
                                                    />
                                                </rkm-col>

                                                <rkm-col cols="2">
                                                    <rkm-form-select
                                                        :options="form.localDomicilio"
                                                        @change="changeLocalDomicilio"
                                                        default-option-text="Todos"
                                                        label="Local do domicílio"
                                                        show-default-option
                                                        text-field="nome"
                                                        v-model="model.localDomicilioId"
                                                        value-field="id"
                                                    />
                                                </rkm-col>
                                            </rkm-row>

                                            <rkm-row>
                                                <rkm-col>
                                                    <rkm-form-select
                                                        :options="form.areaEquipe"
                                                        @change="changeAreaEquipe"
                                                        default-option-text="Todos"
                                                        label="Área da Equipe"
                                                        show-default-option
                                                        text-field="nome"
                                                        v-model="model.areaEquipeId"
                                                        value-field="id"
                                                    />
                                                </rkm-col>

                                                <rkm-col>
                                                    <rkm-form-select
                                                        :options="form.microArea"
                                                        @change="changeMicroArea"
                                                        default-option-text="Todos"
                                                        label="Micro área"
                                                        show-default-option
                                                        text-field="nome"
                                                        v-model="model.microAreaId"
                                                        value-field="id"
                                                    />
                                                </rkm-col>

                                                <rkm-col>
                                                    <rkm-form-select
                                                        :options="form.profissional"
                                                        @change="changeProfissional"
                                                        default-option-text="Todos"
                                                        label="Profissional"
                                                        show-default-option
                                                        text-field="nome"
                                                        v-model="model.profissionalId"
                                                        value-field="id"
                                                    />
                                                </rkm-col>
                                            </rkm-row>
                                        </rkm-collapse>
                                    </rkm-area>
                                </rkm-col>
                            </rkm-row>

                            <rkm-row>
                                <rkm-col>
                                    <rkm-area
                                        title="Paciente"
                                        type="fieldset"
                                    >
                                        <template slot="trailing">
                                            <rkm-button
                                                @click="visiblePaciente = !visiblePaciente"
                                                color="primary"
                                                small
                                            >
                                                <rkm-icon :icon="visiblePaciente ? 'angle-double-up' : 'angle-double-down'" />
                                            </rkm-button>
                                        </template>

                                        <rkm-collapse :visible="visiblePaciente">
                                            <rkm-row>
                                                <rkm-col cols="2">
                                                    <rkm-form-select
                                                        :options="form.classificacaoPaciente"
                                                        @change="changeClassificacaoPaciente"
                                                        default-option-text="Todos"
                                                        label="Classificação"
                                                        show-default-option
                                                        text-field="nome"
                                                        v-model="model.classificacaoPacienteId"
                                                        value-field="id"
                                                    />
                                                </rkm-col>

                                                <rkm-col cols="1">
                                                    <rkm-form-input
                                                        @change="changeIdadeAnosDe"
                                                        label="Anos de"
                                                        number
                                                        v-model="model.idade.anosDe"
                                                    />
                                                </rkm-col>

                                                <rkm-col cols="1">
                                                    <rkm-form-input
                                                        @change="changeIdadeMesesDe"
                                                        label="Meses de"
                                                        number
                                                        v-model="model.idade.mesesDe"
                                                    />
                                                </rkm-col>

                                                <rkm-col cols="1">
                                                    <rkm-form-input
                                                        @change="changeIdadeDiasDe"
                                                        label="Dias de"
                                                        number
                                                        v-model="model.idade.diasDe"
                                                    />
                                                </rkm-col>

                                                <rkm-col cols="1">
                                                    <rkm-form-input
                                                        @change="changeIdadeAnosAte"
                                                        label="Anos até"
                                                        number
                                                        v-model="model.idade.anosAte"
                                                    />
                                                </rkm-col>

                                                <rkm-col cols="1">
                                                    <rkm-form-input
                                                        @change="changeIdadeMesesAte"
                                                        label="Meses até"
                                                        number
                                                        v-model="model.idade.mesesAte"
                                                    />
                                                </rkm-col>

                                                <rkm-col cols="1">
                                                    <rkm-form-input
                                                        @change="changeIdadeDiasAte"
                                                        label="Dias até"
                                                        number
                                                        v-model="model.idade.diasAte"
                                                    />
                                                </rkm-col>

                                                <rkm-col>
                                                    <rkm-form-input-autocomplete
                                                        :repository="repositories.relatorioEstatisticoPacienteCadastrado.paciente"
                                                        :request-query-string-params="autocompleteRequestParams.paciente"
                                                        :search-fields="pacienteSearchFields"
                                                        :text-field="p => `${p.nome}${p.nomeSocial ? ` (${p.nomeSocial})` : ''}${p.cns ? ` - ${p.cns}` : ''}${p.prontuario ? ` - ${p.prontuario}` : ''}`"
                                                        @change="changePaciente"
                                                        label="Paciente"
                                                        placeholder="Nome, Nome social, CNS, ou Prontuário"
                                                        v-model="pacienteLocal"
                                                    />
                                                </rkm-col>
                                            </rkm-row>
                                        </rkm-collapse>
                                    </rkm-area>
                                </rkm-col>
                            </rkm-row>

                            <rkm-row>
                                <rkm-col>
                                    <rkm-area
                                        title="Condicionalidades"
                                        type="fieldset"
                                    >
                                        <template slot="trailing">
                                            <rkm-button
                                                @click="visibleCondicionalidades = !visibleCondicionalidades"
                                                color="primary"
                                                small
                                            >
                                                <rkm-icon :icon="visibleCondicionalidades ? 'angle-double-up' : 'angle-double-down'" />
                                            </rkm-button>
                                        </template>

                                        <rkm-collapse :visible="visibleCondicionalidades">
                                            <rkm-row>
                                                <rkm-col cols="2">
                                                    <rkm-form-select
                                                        :options="form.condicionalidades.sexo"
                                                        @change="changeCondicionalidadesSexo"
                                                        default-option-text="Todos"
                                                        label="Sexo"
                                                        show-default-option
                                                        text-field="nome"
                                                        v-model="model.condicionalidades.sexoId"
                                                        value-field="id"
                                                    />
                                                </rkm-col>

                                                <rkm-col cols="1">
                                                    <rkm-form-select
                                                        :options="form.condicionalidades.peso"
                                                        @change="changeCondicionalidadesPeso"
                                                        default-option-text="Todos"
                                                        label="Peso"
                                                        show-default-option
                                                        text-field="nome"
                                                        v-model="model.condicionalidades.pesoId"
                                                        value-field="id"
                                                    />
                                                </rkm-col>

                                                <rkm-col cols="1">
                                                    <rkm-form-select
                                                        :options="form.condicionalidades.gestante"
                                                        @change="changeCondicionalidadesGestante"
                                                        default-option-text="Todos"
                                                        label="Gestante"
                                                        show-default-option
                                                        text-field="nome"
                                                        v-model="model.condicionalidades.gestanteId"
                                                        value-field="id"
                                                    />
                                                </rkm-col>

                                                    <rkm-col cols="1">
                                                        <rkm-form-select
                                                            :options="form.condicionalidades.hipertenso"
                                                            @change="changeCondicionalidadesHipertenso"
                                                            default-option-text="Todos"
                                                            label="Hipertenso"
                                                            show-default-option
                                                            text-field="nome"
                                                            v-model="model.condicionalidades.hipertensoId"
                                                            value-field="id"
                                                        />
                                                    </rkm-col>

                                                <rkm-col cols="1">
                                                    <rkm-form-select
                                                        :options="form.condicionalidades.diabetico"
                                                        @change="changeCondicionalidadesDiabetico"
                                                        default-option-text="Todos"
                                                        label="Diabético"
                                                        show-default-option
                                                        text-field="nome"
                                                        v-model="model.condicionalidades.diabeticoId"
                                                        value-field="id"
                                                    />
                                                </rkm-col>

                                                <rkm-col cols="1">
                                                    <rkm-form-select
                                                        :options="form.condicionalidades.hanseniase"
                                                        @change="changeCondicionalidadeshanseniase"
                                                        default-option-text="Todos"
                                                        label="Hanseníase"
                                                        show-default-option
                                                        text-field="nome"
                                                        v-model="model.condicionalidades.hanseniaseId"
                                                        value-field="id"
                                                    />
                                                </rkm-col>

                                                <rkm-col cols="1">
                                                    <rkm-form-select
                                                        :options="form.condicionalidades.tuberculose"
                                                        @change="changeCondicionalidadesTuberculose"
                                                        default-option-text="Todos"
                                                        label="Tuberculose"
                                                        show-default-option
                                                        text-field="nome"
                                                        v-model="model.condicionalidades.tuberculoseId"
                                                        value-field="id"
                                                    />
                                                </rkm-col>

                                                <rkm-col cols="1">
                                                    <rkm-form-select
                                                        :options="form.condicionalidades.fumante"
                                                        @change="changeCondicionalidadesFumante"
                                                        default-option-text="Todos"
                                                        label="Fumante"
                                                        show-default-option
                                                        text-field="nome"
                                                        v-model="model.condicionalidades.fumanteId"
                                                        value-field="id"
                                                    />
                                                </rkm-col>

                                                <rkm-col cols="1">
                                                    <rkm-form-select
                                                        :options="form.condicionalidades.alcool"
                                                        @change="changeCondicionalidadesAlcool"
                                                        default-option-text="Todos"
                                                        label="Álcool"
                                                        show-default-option
                                                        text-field="nome"
                                                        v-model="model.condicionalidades.alcoolId"
                                                        value-field="id"
                                                    />
                                                </rkm-col>

                                                <rkm-col cols="1">
                                                    <rkm-form-select
                                                        :options="form.condicionalidades.drogas"
                                                        @change="changeCondicionalidadesDrogas"
                                                        default-option-text="Todos"
                                                        label="Drogas"
                                                        show-default-option
                                                        text-field="nome"
                                                        v-model="model.condicionalidades.drogasId"
                                                        value-field="id"
                                                    />
                                                </rkm-col>

                                                <rkm-col cols="1">
                                                    <rkm-form-select
                                                        :options="form.condicionalidades.tea"
                                                        @change="changeCondicionalidadesTea"
                                                        default-option-text="Todos"
                                                        label="TEA"
                                                        show-default-option
                                                        text-field="nome"
                                                        title="Transtorno do Espectro Autista"
                                                        v-model="model.condicionalidades.teaId"
                                                        value-field="id"
                                                    />
                                                </rkm-col>
                                            </rkm-row>
                                        </rkm-collapse>
                                    </rkm-area>
                                </rkm-col>
                            </rkm-row>

                            <rkm-row>
                                <rkm-col>
                                    <rkm-area
                                        title="Outras Doenças/Tratamentos"
                                        type="fieldset"
                                    >
                                        <template slot="trailing">
                                            <rkm-button
                                                @click="visibleOutras = !visibleOutras"
                                                color="primary"
                                                small
                                            >
                                                <rkm-icon :icon="visibleOutras ? 'angle-double-up' : 'angle-double-down'" />
                                            </rkm-button>
                                        </template>

                                        <rkm-collapse :visible="visibleOutras">
                                            <rkm-row>
                                                <rkm-col cols="2">
                                                    <rkm-form-select
                                                        :options="form.outrasDoencas.avc"
                                                        @change="changeOutrasDoencasAvc"
                                                        default-option-text="Todos"
                                                        label="Avc/Derrame"
                                                        show-default-option
                                                        text-field="nome"
                                                        v-model="model.outrasDoencas.avcId"
                                                        value-field="id"
                                                    />
                                                </rkm-col>

                                                <rkm-col cols="2">
                                                    <rkm-form-select
                                                        :options="form.outrasDoencas.infarto"
                                                        @change="changeOutrasDoencasInfarto"
                                                        default-option-text="Todos"
                                                        label="Infarto"
                                                        show-default-option
                                                        text-field="nome"
                                                        v-model="model.outrasDoencas.infartoId"
                                                        value-field="id"
                                                    />
                                                </rkm-col>

                                                <rkm-col cols="2">
                                                    <rkm-form-select
                                                        :options="form.outrasDoencas.cancer"
                                                        @change="changeOutrasDoencasCancer"
                                                        default-option-text="Todos"
                                                        label="Câncer"
                                                        show-default-option
                                                        text-field="nome"
                                                        v-model="model.outrasDoencas.cancerId"
                                                        value-field="id"
                                                    />
                                                </rkm-col>

                                                <rkm-col cols="2">
                                                    <rkm-form-select
                                                        :options="form.outrasDoencas.fibromialgia"
                                                        @change="changeOutrasDoencasFibromialgia"
                                                        default-option-text="Todos"
                                                        label="Fibromialgia"
                                                        show-default-option
                                                        text-field="nome"
                                                        v-model="model.outrasDoencas.fibromialgiaId"
                                                        value-field="id"
                                                    />
                                                </rkm-col>

                                                <rkm-col cols="2">
                                                    <rkm-form-select
                                                        :options="form.outrasDoencas.internacao"
                                                        @change="changeOutrasDoencasInternacao"
                                                        default-option-text="Todos"
                                                        label="Internação"
                                                        show-default-option
                                                        text-field="nome"
                                                        v-model="model.outrasDoencas.internacaoId"
                                                        value-field="id"
                                                    />
                                                </rkm-col>

                                                <rkm-col cols="2">
                                                    <rkm-form-select
                                                        :options="form.outrasDoencas.doencaCardiaca"
                                                        @change="changeOutrasDoencasDoencaCardiaca"
                                                        default-option-text="Todos"
                                                        label="Doença cardíaca"
                                                        show-default-option
                                                        text-field="nome"
                                                        v-model="model.outrasDoencas.doencaCardiacaId"
                                                        value-field="id"
                                                    />
                                                </rkm-col>
                                            </rkm-row>

                                            <rkm-row>
                                                <rkm-col cols="2">
                                                    <rkm-form-select
                                                        :options="form.outrasDoencas.doencaRenal"
                                                        @change="changeOutrasDoencasDoencaRenal"
                                                        default-option-text="Todos"
                                                        label="Doença renal"
                                                        show-default-option
                                                        text-field="nome"
                                                        v-model="model.outrasDoencas.doencaRenalId"
                                                        value-field="id"
                                                    />
                                                </rkm-col>

                                                <rkm-col cols="2">
                                                    <rkm-form-select
                                                        :options="form.outrasDoencas.doencaRespiratoria"
                                                        @change="changeOutrasDoencasDoencaRespiratoria"
                                                        default-option-text="Todos"
                                                        label="Doença respiratória"
                                                        show-default-option
                                                        text-field="nome"
                                                        v-model="model.outrasDoencas.doencaRespiratoriaId"
                                                        value-field="id"
                                                    />
                                                </rkm-col>

                                                <rkm-col cols="2">
                                                    <rkm-form-select
                                                        :options="form.outrasDoencas.tratamentoPsicologico"
                                                        @change="changeOutrasDoencasTratamentoPsicologico"
                                                        default-option-text="Todos"
                                                        label="Tratamento psiquiátrico"
                                                        show-default-option
                                                        text-field="nome"
                                                        v-model="model.outrasDoencas.tratamentoPsicologicoId"
                                                        value-field="id"
                                                    />
                                                </rkm-col>

                                                <rkm-col cols="2">
                                                    <rkm-form-select
                                                        :options="form.outrasDoencas.plantasMedicinais"
                                                        @change="changeOutrasDoencasPlantasMedicinais"
                                                        default-option-text="Todos"
                                                        label="Plantas medicinais"
                                                        show-default-option
                                                        text-field="nome"
                                                        v-model="model.outrasDoencas.plantasMedicinaisId"
                                                        value-field="id"
                                                    />
                                                </rkm-col>

                                                <rkm-col cols="4">
                                                    <rkm-form-select
                                                        :options="form.outrasDoencas.praticasIntegrativas"
                                                        @change="changeOutrasDoencasPraticasIntegrativas"
                                                        default-option-text="Todos"
                                                        label="Práticas integrativas e complementares"
                                                        show-default-option
                                                        text-field="nome"
                                                        v-model="model.outrasDoencas.praticasIntegrativasId"
                                                        value-field="id"
                                                    />
                                                </rkm-col>
                                            </rkm-row>
                                        </rkm-collapse>
                                    </rkm-area>
                                </rkm-col>
                            </rkm-row>

                            <rkm-row>
                                <rkm-col>
                                    <rkm-area
                                        title="Atenção Domiciliar"
                                        type="fieldset"
                                    >
                                        <template slot="trailing">
                                            <rkm-button
                                                @click="visibleDomiciliar = !visibleDomiciliar"
                                                color="primary"
                                                small
                                            >
                                                <rkm-icon :icon="visibleDomiciliar ? 'angle-double-up' : 'angle-double-down'" />
                                            </rkm-button>
                                        </template>

                                        <rkm-collapse :visible="visibleDomiciliar">
                                            <rkm-row>
                                                <rkm-col>
                                                    <rkm-form-select
                                                        :options="form.atencaoDomiciliar.acamado"
                                                        @change="changeAtencaoDomiciliarAcamado"
                                                        default-option-text="Todos"
                                                        label="Acamado"
                                                        show-default-option
                                                        text-field="nome"
                                                        v-model="model.atencaoDomiciliar.acamadoId"
                                                        value-field="id"
                                                    />
                                                </rkm-col>

                                                <rkm-col>
                                                    <rkm-form-select
                                                        :options="form.atencaoDomiciliar.domiciliado"
                                                        default-option-text="Todos"
                                                        label="Domiciliado"
                                                        show-default-option
                                                        text-field="nome"
                                                        v-model="model.atencaoDomiciliar.domiciliadoId"
                                                        value-field="id"
                                                    />
                                                </rkm-col>
                                            </rkm-row>
                                        </rkm-collapse>
                                    </rkm-area>
                                </rkm-col>
                            </rkm-row>

                            <div class="text-right mt-3">
                                <rkm-button
                                    @click="search"
                                    :label="false"
                                    color="primary"
                                >
                                    Buscar
                                </rkm-button>

                                <rkm-button
                                    @click="clear"
                                    :label="false"
                                    color="secondary"
                                >
                                    Limpar
                                </rkm-button>
                            </div>
                        </rkm-area>
                    </rkm-col>
                </rkm-row>
            </rkm-form>

            <rkm-area
                no-margin-top
                title="Resultado"
            >
                <template v-slot:trailing>
                    <rkm-dropdown
                        class="mr-2"
                        color="primary"
                        cols="1"
                        menu-class="auto-scroll"
                        no-caret
                        small
                        title="Colunas"
                        v-rkm-tooltip.hover
                    >
                        <template v-slot:button-content>
                            <rkm-icon icon="columns" />
                        </template>

                        <rkm-form-checkbox
                            :indeterminate="indeterminate"
                            @change="handleSelectedColumns"
                            class="mx-2"
                        >
                            Todas
                        </rkm-form-checkbox>

                        <rkm-form-checkbox-group
                            :options="cols"
                            class="mx-2"
                            stacked
                            v-model="selectedCols"
                        />
                    </rkm-dropdown>

                    <rkm-button
                        :disabled="!items.length"
                        @click="print"
                        color="info"
                        small
                        title="Imprimir"
                    >
                        <rkm-icon icon="print" />
                    </rkm-button>

                    <rkm-button
                        :disabled="!items.length"
                        @click="exportTo"
                        color="info"
                        small
                        title="Exportar"
                    >
                        <rkm-icon icon="file-export" />
                    </rkm-button>
                </template>

                <rkm-table
                    :fields="fields"
                    :items="items"
                    :sort-by.sync="sortBy"
                    :sort-compare="sortCompare"
                    :sort-desc.sync="sortDesc"
                    @sort-changed="onSortChanged"
                >
                    <template #afterTable v-if="items.length > 0">
                        <rkm-area
                            title="Totalizadores"
                        >
                            <rkm-row class="mt-2">
                                <rkm-col
                                    cols="auto"
                                    class="total"
                                >
                                    <strong>
                                        Total de pacientes: {{ totalPacientes }}
                                    </strong>
                                </rkm-col>
                            </rkm-row>

                            <rkm-row>
                                <rkm-col
                                    cols="auto"
                                    class="text-right"
                                >
                                    <strong>
                                        Total de familias: {{ totalFamilias }}
                                    </strong>
                                </rkm-col>
                            </rkm-row>

                            <rkm-row>
                                <rkm-col
                                    cols="auto"
                                    class="text-right"
                                >
                                    <strong>
                                        Total por sexo:
                                    </strong>
                                </rkm-col>

                                <rkm-col cols="auto">
                                    Masculino: {{ totalPacientesPorSexo.masculino }}
                                </rkm-col>

                                <rkm-col cols="auto">
                                    Feminino: {{ totalPacientesPorSexo.feminino }}
                                </rkm-col>

                                <rkm-col cols="5">
                                    Indeterminado: {{ totalPacientesPorSexo.indeterminado }}
                                </rkm-col>
                            </rkm-row>

                            <rkm-row class="align-items-center">
                                <rkm-col cols="auto">
                                    <strong>Total por área:</strong>
                                </rkm-col>

                                <rkm-col
                                    v-for="([areaId, total]) in Object.entries(totalPacientesPorArea)"
                                    :key="areaId"
                                    cols="auto"
                                >
                                    {{ areaId + ': ' + total }}
                                </rkm-col>
                            </rkm-row>

                            <rkm-row class="align-items-center">
                                <rkm-col cols="auto">
                                    <strong>Total por micro área:</strong>
                                </rkm-col>

                                <rkm-col
                                    v-for="([microAreaId, total]) in Object.entries(totalPacientesPorMicroArea)"
                                    :key="microAreaId"
                                    cols="auto"
                                >
                                    {{ microAreaId + ': ' + total }}
                                </rkm-col>
                            </rkm-row>
                        </rkm-area>
                    </template>
                </rkm-table>
            </rkm-area>
        </template>

    </div>
</template>

<script>

// Mixins.
import { repository, error, data, object, stringCase, formats, file } from '@/mixins'

// Others.
import moment from 'moment'

// Vuex.
import { mapActions } from 'vuex'

export default {
    ...mapActions(["setLoading", "unsetLoading"]),
    computed: {
        autocompleteRequestParams() {
            return {
                paciente: {
                    unidade_equipe_id: this.model.unidadeEquipeId,
                    area_equipe_id: this.model.areaEquipeId,
                    micro_area_id: this.model.microAreaId,
                    local_domicilio_id: this.model.localDomicilioId,
                    profissional: this.model.profissionalId,
                    classificacao_paciente_id: this.model.classificacaoPacienteId,
                    idade_anos_de: this.model.idade.anosDe,
                    idade_anos_ate: this.model.idade.anosAte,
                    idade_meses_de: this.model.idade.mesesDe,
                    idade_meses_ate: this.model.idade.mesesAte,
                    idade_dias_de: this.model.idade.diasDe,
                    idade_dias_ate: this.model.idade.diasAte,
                }
            }
        },
        validations() {
            return {
                unidadeEquipeId: { required: true },
                infraestruturaEquipeId: { required: true },
            }
        },
        fields() {
            let fields = [
                {key: 'nomePaciente', label: 'Nome paciente', name: 'nome_paciente', sortable: true},
                {key: 'sexoPaciente', label: 'Sexo', name: 'sexo_paciente', sortable: true},
                {key: 'idadeAnosPaciente', label: 'Idade (Anos)', name: 'idade_anos_paciente', sortable: true},
                {key: 'idadeMesesPaciente', label: 'Idade (Meses)', name: 'idade_meses_paciente', sortable: true},
                {key: 'idadeDiasPaciente', label: 'Idade (Dias)', name: 'idade_dias_paciente', sortable: true},
                {key: 'classificacaoPaciente', label: 'Classificação', name: 'classificacao_paciente', sortable: true},
                {key: 'profissional', label: 'Profissional', name: 'profissional', sortable: true},
                {key: 'responsavelCadastro', label: 'Responsável pelo Cadastro', name: 'responsavel_cadastro', sortable: true},
                {key: 'enderecoPaciente', label: 'Endereço', name: 'endereco_paciente', sortable: true},
                {key: 'pesoPaciente', label: 'Peso', name: 'peso_paciente', sortable: true},
                {key: 'gestante', label: 'Gestante', name: 'gestante', sortable: true},
                {key: 'hipertenso', label: 'Hipertenso', name: 'hipertenso', sortable: true},
                {key: 'diabetico', label: 'Diabéticos', name: 'diabetico', sortable: true},
                {key: 'hanseniase', label: 'Hanseníase', name: 'hanseniase', sortable: true},
                {key: 'tuberculose', label: 'Tuberculose', name: 'tuberculose', sortable: true},
                {key: 'fumante', label: 'Fumante', name: 'fumante', sortable: true},
                {key: 'alcool', label: 'Álcool', name: 'alcool', sortable: true},
                {key: 'drogas', label: 'Drogas', name: 'drogas', sortable: true},
                {key: 'tea', label: 'TEA (Transtorno do Espectro Autista)', name: 'tea', sortable: true},
            ]

            this.selectedCols.map(column => {
                const col = this.cols.find(find => find.value === column)
                if (col.value !== 'todas') {
                    fields.push({ key: col.value, label: col.text, sortable: true  })
                }
            })

            return fields
        },
        cols() {
            return this.columns
        },
        pacienteSearchFields() {
            return [
                { key: 'cidadao.nome', searchable: true },
                { key: 'cidadao.nomeSocial', searchable: true },
                { key: 'cidadao.cns', searchable: true },
                { key: 'cadastroPaciente.prontuario', searchable: true },
            ]
        },
        checkAreaEquipe() {
            return this.model.localDomicilioId !== null;
        },
        checkMicroArea() {
            return this.model.localDomicilioId !== null;
        },
    },
    created() {
        this.repositories = {
            relatorioEstatisticoPacienteCadastrado: this.getConectaSusRepository('atencaoBasica.relatorioEstatisticoPacienteCadastrado'),
            impressao: this.getConectaSusRepository('impressao.atencaoBasica'),
            exportacao: this.getConectaSusRepository('exportacao.atencaoBasica'),
        }

        this.load()
    },
    data: () => ({
        visibleEquipe: true,
        visiblePaciente: false,
        visibleCondicionalidades: false,
        visibleOutras: false,
        visibleDomiciliar: false,
        selectedCols: [],
        isLoaded: false,
        model: null,
        initialModel: null,
        form: null,
        additionals: null,
        totalPacientes: null,
        sortBy: null,
        sortDesc: false,
        pacienteLocal: null,
        columns: [
            {
                value: 'avc',
                text: 'Avc/ Derrame',
            },
            {
                value: 'infarto',
                text: 'Infarto',
            },
            {
                value: 'cancer',
                text: 'Câncer',
            },
            {
                value: 'fibromialgia',
                text: 'Fibromialgia',
            },
            {
                value: 'internacao',
                text: 'Internação',
            },
            {
                value: 'doencaCardiaca',
                text: 'Doença Cardíaca',
            },
            {
                value: 'doencaRenal',
                text: 'Doença Renal',
            },
            {
                value: 'doencaRespiratoria',
                text: 'Doença Respiratória',
            },
            {
                value: 'tratamentoSaudeMental',
                text: 'Tratamento Psiquiátrico',
            },
            {
                value: 'plantasMedicinais',
                text: 'Plantas Medicinais',
            },
            {
                value: 'praticasIntegrativas',
                text: 'Práticas Integrativas e Complementares',
            },
            {
                value: 'acamado',
                text: 'Acamado',
            },
            {
                value: 'domiciliado',
                text: 'Domiciliado',
            },
            {
                value: 'enderecoCompleto',
                text: 'Endereço completo do paciente',
            },
        ],
        indeterminate: false,
        items: [],
    }),
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        load() {
            this.setLoading();

            this.repositories.relatorioEstatisticoPacienteCadastrado
                .list()
                .then(({ data }) => {
                    this.form = data.form
                    this.model = data.model
                    this.additionals = data.additionals
                    this.initialModel = this.clone(this.model)

                    this.isLoaded = true
                })
                .catch(error => {
                    this.error(error)
                })
                .finally(() => {
                    this.unsetLoading()
                })
        },
        sortCompare(a, b, key) {
            if (key === 'dataAtendimento') {
                const dateA = moment(a[key], 'DD/MM/YYYY')
                const dateB = moment(b[key], 'DD/MM/YYYY')

                if (dateA > dateB) return 1
                else if (dateA < dateB) return -1
                else return 0

            } else {

                return false
            }
        },
        handleSelectedColumns(selected) {
            if (selected) {
                this.cols.map(col => {
                    this.selectedCols.push(col.value)
                })
            } else {
                this.selectedCols = []
            }
        },
        changeUnidadeEquipe() {
            this.setLoading()
            this.items = []

            this.model.infraestruturaEquipeId = null
            this.model.localDomicilioId = null
            this.model.areaEquipeId = null
            this.model.microAreaId = null
            this.model.profissionalId = null
            this.model.classificacaoPacienteId = null
            this.model.idade.anosDe = null
            this.model.idade.mesesDe = null
            this.model.idade.diasDe = null
            this.model.idade.anosAte = null
            this.model.idade.mesesAte = null
            this.model.idade.diasAte = null

            this.model.paciente = null
            this.model.condicionalidades.sexoId = null
            this.model.condicionalidades.pesoId = null
            this.model.condicionalidades.gestanteId = null
            this.model.condicionalidades.hipertensoId = null
            this.model.condicionalidades.diabeticoId = null
            this.model.condicionalidades.hanseniaseId = null
            this.model.condicionalidades.tuberculoseId = null
            this.model.condicionalidades.fumanteId = null
            this.model.condicionalidades.alcoolId = null
            this.model.condicionalidades.drogasId = null
            this.model.condicionalidades.teaId = null

            this.model.outrasDoencas.avcId = null
            this.model.outrasDoencas.infartoId = null
            this.model.outrasDoencas.cancerId = null
            this.model.outrasDoencas.fibromialgiaId = null
            this.model.outrasDoencas.internacaoId = null
            this.model.outrasDoencas.doencaCardiacaId = null
            this.model.outrasDoencas.doencaRenalId = null
            this.model.outrasDoencas.doencaRespiratoriaId = null
            this.model.outrasDoencas.tratamentoPsicologicoId = null
            this.model.outrasDoencas.plantasMedicinaisId = null
            this.model.outrasDoencas.praticasIntegrativasId = null

            this.model.atencaoDomiciliar.acamadoId = null
            this.model.atencaoDomiciliar.domiciliadoId = null

            const filter = {
                ...this.getFilter(),
                fields_to_load: [
                    'infraestrutura_equipe',
                    'local_domicilio',
                    'area_equipe',
                    'micro_area',
                    'profissional',
                    'classificacao_paciente',
                    'sexo',
                    'peso',
                    'gestante',
                    'hipertenso',
                    'diabetico',
                    'hanseniase',
                    'tuberculose',
                    'fumante',
                    'alcool',
                    'drogas',
                    'tea',
                    'avc',
                    'infarto',
                    'cancer',
                    'fibromialgia',
                    'internacao',
                    'doenca_cardiaca',
                    'doenca_renal',
                    'doenca_respiratoria',
                    'tratamento_psicologico',
                    'plantas_medicinais',
                    'praticas_integrativas',
                    'acamado',
                    'domiciliado'
                ]
            }

            this.repositories.relatorioEstatisticoPacienteCadastrado.list(filter)
                .then(({ data }) => {
                    this.form.infraestruturaEquipe = this.clone(data.form.infraestruturaEquipe);
                    this.form.localDomicilio = this.clone(data.form.localDomicilio);
                    this.form.areaEquipe = this.clone(data.form.areaEquipe);
                    this.form.microArea = this.clone(data.form.microArea);
                    this.form.profissional = this.clone(data.form.profissional);
                    this.form.classificacaoPaciente = this.clone(data.form.classificacaoPaciente);
                    this.form.condicionalidades = this.clone(data.form.condicionalidades);
                    this.form.outrasDoencas = this.clone(data.form.outrasDoencas);
                    this.form.atencaoDomiciliar = this.clone(data.form.atencaoDomiciliar);

                    if (this.form.infraestruturaEquipe.length === 1 && this.model.infraestruturaEquipeId === null) {
                        this.model.infraestruturaEquipeId = this.form.infraestruturaEquipe[0].id
                    }
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        changeInfraestruturaEquipe() {
            this.setLoading()
            this.items = []

            this.model.localDomicilioId = null
            this.model.areaEquipeId = null
            this.model.microAreaId = null
            this.model.profissionalId = null
            this.model.classificacaoPacienteId = null
            this.model.idade.anosDe = null
            this.model.idade.mesesDe = null
            this.model.idade.diasDe = null
            this.model.idade.anosAte = null
            this.model.idade.mesesAte = null
            this.model.idade.diasAte = null

            this.model.paciente = null
            this.model.condicionalidades.sexoId = null
            this.model.condicionalidades.pesoId = null
            this.model.condicionalidades.gestanteId = null
            this.model.condicionalidades.hipertensoId = null
            this.model.condicionalidades.diabeticoId = null
            this.model.condicionalidades.hanseniaseId = null
            this.model.condicionalidades.tuberculoseId = null
            this.model.condicionalidades.fumanteId = null
            this.model.condicionalidades.alcoolId = null
            this.model.condicionalidades.drogasId = null
            this.model.condicionalidades.teaId = null

            this.model.outrasDoencas.avcId = null
            this.model.outrasDoencas.infartoId = null
            this.model.outrasDoencas.cancerId = null
            this.model.outrasDoencas.fibromialgiaId = null
            this.model.outrasDoencas.internacaoId = null
            this.model.outrasDoencas.doencaCardiacaId = null
            this.model.outrasDoencas.doencaRenalId = null
            this.model.outrasDoencas.doencaRespiratoriaId = null
            this.model.outrasDoencas.tratamentoPsicologicoId = null
            this.model.outrasDoencas.plantasMedicinaisId = null
            this.model.outrasDoencas.praticasIntegrativasId = null

            this.model.atencaoDomiciliar.acamadoId = null
            this.model.atencaoDomiciliar.domiciliadoId = null

            const filter = {
                ...this.getFilter(),
                fields_to_load: [
                    'local_domicilio',
                    'area_equipe',
                    'micro_area',
                    'profissional',
                    'classificacao_paciente',
                    'sexo',
                    'peso',
                    'gestante',
                    'hipertenso',
                    'diabetico',
                    'hanseniase',
                    'tuberculose',
                    'fumante',
                    'alcool',
                    'drogas',
                    'tea',
                    'avc',
                    'infarto',
                    'cancer',
                    'fibromialgia',
                    'internacao',
                    'doenca_cardiaca',
                    'doenca_renal',
                    'doenca_respiratoria',
                    'tratamento_psicologico',
                    'plantas_medicinais',
                    'praticas_integrativas',
                    'acamado',
                    'domiciliado'
                ]
            }

            this.repositories.relatorioEstatisticoPacienteCadastrado.list(filter)
                .then(({ data }) => {
                    this.form.localDomicilio = this.clone(data.form.localDomicilio);
                    this.form.areaEquipe = this.clone(data.form.areaEquipe);
                    this.form.microArea = this.clone(data.form.microArea);
                    this.form.profissional = this.clone(data.form.profissional);
                    this.form.classificacaoPaciente = this.clone(data.form.classificacaoPaciente);
                    this.form.condicionalidades = this.clone(data.form.condicionalidades);

                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        changeLocalDomicilio() {
            this.setLoading()
            this.items = []

            this.model.areaEquipeId = null
            this.model.microAreaId = null
            this.model.profissionalId = null
            this.model.classificacaoPacienteId = null
            this.model.idade.anosDe = null
            this.model.idade.mesesDe = null
            this.model.idade.diasDe = null
            this.model.idade.anosAte = null
            this.model.idade.mesesAte = null
            this.model.idade.diasAte = null

            this.model.paciente = null
            this.model.condicionalidades.sexoId = null
            this.model.condicionalidades.pesoId = null
            this.model.condicionalidades.gestanteId = null
            this.model.condicionalidades.hipertensoId = null
            this.model.condicionalidades.diabeticoId = null
            this.model.condicionalidades.hanseniaseId = null
            this.model.condicionalidades.tuberculoseId = null
            this.model.condicionalidades.fumanteId = null
            this.model.condicionalidades.alcoolId = null
            this.model.condicionalidades.drogasId = null
            this.model.condicionalidades.teaId = null

            this.model.outrasDoencas.avcId = null
            this.model.outrasDoencas.infartoId = null
            this.model.outrasDoencas.cancerId = null
            this.model.outrasDoencas.fibromialgiaId = null
            this.model.outrasDoencas.internacaoId = null
            this.model.outrasDoencas.doencaCardiacaId = null
            this.model.outrasDoencas.doencaRenalId = null
            this.model.outrasDoencas.doencaRespiratoriaId = null
            this.model.outrasDoencas.tratamentoPsicologicoId = null
            this.model.outrasDoencas.plantasMedicinaisId = null
            this.model.outrasDoencas.praticasIntegrativasId = null

            this.model.atencaoDomiciliar.acamadoId = null
            this.model.atencaoDomiciliar.domiciliadoId = null

            const filter = {
                ...this.getFilter(),
                fields_to_load: [
                    'area_equipe',
                    'micro_area',
                    'profissional',
                    'classificacao_paciente',
                    'sexo',
                    'peso',
                    'gestante',
                    'hipertenso',
                    'diabetico',
                    'hanseniase',
                    'tuberculose',
                    'fumante',
                    'alcool',
                    'drogas',
                    'tea',
                    'avc',
                    'infarto',
                    'cancer',
                    'fibromialgia',
                    'internacao',
                    'doenca_cardiaca',
                    'doenca_renal',
                    'doenca_respiratoria',
                    'tratamento_psicologico',
                    'plantas_medicinais',
                    'praticas_integrativas',
                    'acamado',
                    'domiciliado'
                ]
            }

            this.repositories.relatorioEstatisticoPacienteCadastrado.list(filter)
                .then(({ data }) => {
                    this.form.areaEquipe = this.clone(data.form.areaEquipe);
                    this.form.microArea = this.clone(data.form.microArea);
                    this.form.profissional = this.clone(data.form.profissional);
                    this.form.classificacaoPaciente = this.clone(data.form.classificacaoPaciente);
                    this.form.condicionalidades = this.clone(data.form.condicionalidades);

                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        changeAreaEquipe() {
            this.setLoading()
            this.items = []

            this.model.microAreaId = null
            this.model.profissionalId = null
            this.model.classificacaoPacienteId = null
            this.model.idade.anosDe = null
            this.model.idade.mesesDe = null
            this.model.idade.diasDe = null
            this.model.idade.anosAte = null
            this.model.idade.mesesAte = null
            this.model.idade.diasAte = null

            this.model.paciente = null
            this.model.condicionalidades.sexoId = null
            this.model.condicionalidades.pesoId = null
            this.model.condicionalidades.gestanteId = null
            this.model.condicionalidades.hipertensoId = null
            this.model.condicionalidades.diabeticoId = null
            this.model.condicionalidades.hanseniaseId = null
            this.model.condicionalidades.tuberculoseId = null
            this.model.condicionalidades.fumanteId = null
            this.model.condicionalidades.alcoolId = null
            this.model.condicionalidades.drogasId = null
            this.model.condicionalidades.teaId = null

            this.model.outrasDoencas.avcId = null
            this.model.outrasDoencas.infartoId = null
            this.model.outrasDoencas.cancerId = null
            this.model.outrasDoencas.fibromialgiaId = null
            this.model.outrasDoencas.internacaoId = null
            this.model.outrasDoencas.doencaCardiacaId = null
            this.model.outrasDoencas.doencaRenalId = null
            this.model.outrasDoencas.doencaRespiratoriaId = null
            this.model.outrasDoencas.tratamentoPsicologicoId = null
            this.model.outrasDoencas.plantasMedicinaisId = null
            this.model.outrasDoencas.praticasIntegrativasId = null

            this.model.atencaoDomiciliar.acamadoId = null
            this.model.atencaoDomiciliar.domiciliadoId = null

            const filter = {
                ...this.getFilter(),
                fields_to_load: [
                    'micro_area',
                    'profissional',
                    'classificacao_paciente',
                    'sexo',
                    'peso',
                    'gestante',
                    'hipertenso',
                    'diabetico',
                    'hanseniase',
                    'tuberculose',
                    'fumante',
                    'alcool',
                    'drogas',
                    'tea',
                    'avc',
                    'infarto',
                    'cancer',
                    'fibromialgia',
                    'internacao',
                    'doenca_cardiaca',
                    'doenca_renal',
                    'doenca_respiratoria',
                    'tratamento_psicologico',
                    'plantas_medicinais',
                    'praticas_integrativas',
                    'acamado',
                    'domiciliado'
                ]
            }

            this.repositories.relatorioEstatisticoPacienteCadastrado.list(filter)
                .then(({ data }) => {
                    this.form.microArea = this.clone(data.form.microArea);
                    this.form.profissional = this.clone(data.form.profissional);
                    this.form.classificacaoPaciente = this.clone(data.form.classificacaoPaciente);
                    this.form.idade = this.clone(data.form.idade);
                    this.form.paciente = this.clone(data.form.paciente);
                    this.form.condicionalidades = this.clone(data.form.condicionalidades);
                    this.form.outrasDoencas = this.clone(data.form.outrasDoencas);
                    this.form.atencaoDomiciliar = this.clone(data.form.atencaoDomiciliar);
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        changeMicroArea() {
            this.setLoading()
            this.items = []

            this.model.profissionalId = null
            this.model.classificacaoPacienteId = null
            this.model.idade.anosDe = null
            this.model.idade.mesesDe = null
            this.model.idade.diasDe = null
            this.model.idade.anosAte = null
            this.model.idade.mesesAte = null
            this.model.idade.diasAte = null

            this.model.paciente = null
            this.model.condicionalidades.sexoId = null
            this.model.condicionalidades.pesoId = null
            this.model.condicionalidades.gestanteId = null
            this.model.condicionalidades.hipertensoId = null
            this.model.condicionalidades.diabeticoId = null
            this.model.condicionalidades.hanseniaseId = null
            this.model.condicionalidades.tuberculoseId = null
            this.model.condicionalidades.fumanteId = null
            this.model.condicionalidades.alcoolId = null
            this.model.condicionalidades.drogasId = null
            this.model.condicionalidades.teaId = null

            this.model.outrasDoencas.avcId = null
            this.model.outrasDoencas.infartoId = null
            this.model.outrasDoencas.cancerId = null
            this.model.outrasDoencas.fibromialgiaId = null
            this.model.outrasDoencas.internacaoId = null
            this.model.outrasDoencas.doencaCardiacaId = null
            this.model.outrasDoencas.doencaRenalId = null
            this.model.outrasDoencas.doencaRespiratoriaId = null
            this.model.outrasDoencas.tratamentoPsicologicoId = null
            this.model.outrasDoencas.plantasMedicinaisId = null
            this.model.outrasDoencas.praticasIntegrativasId = null

            this.model.atencaoDomiciliar.acamadoId = null
            this.model.atencaoDomiciliar.domiciliadoId = null

            const filter = {
                ...this.getFilter(),
                fields_to_load: [
                    'profissional',
                    'classificacao_paciente',
                    'sexo',
                    'peso',
                    'gestante',
                    'hipertenso',
                    'diabetico',
                    'hanseniase',
                    'tuberculose',
                    'fumante',
                    'alcool',
                    'drogas',
                    'tea',
                    'avc',
                    'infarto',
                    'cancer',
                    'fibromialgia',
                    'internacao',
                    'doenca_cardiaca',
                    'doenca_renal',
                    'doenca_respiratoria',
                    'tratamento_psicologico',
                    'plantas_medicinais',
                    'praticas_integrativas',
                    'acamado',
                    'domiciliado'
                ]
            }

            this.repositories.relatorioEstatisticoPacienteCadastrado.list(filter)
                .then(({ data }) => {

                    this.form.profissional = this.clone(data.form.profissional);
                    this.form.classificacaoPaciente = this.clone(data.form.classificacaoPaciente);
                    this.form.condicionalidades = this.clone(data.form.condicionalidades);
                    this.form.outrasDoencas = this.clone(data.form.outrasDoencas);
                    this.form.atencaoDomiciliar = this.clone(data.form.atencaoDomiciliar);
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        changeProfissional() {
            this.setLoading()
            this.items = []

            this.model.classificacaoPacienteId = null
            this.model.idade.anosDe = null
            this.model.idade.mesesDe = null
            this.model.idade.diasDe = null
            this.model.idade.anosAte = null
            this.model.idade.mesesAte = null
            this.model.idade.diasAte = null

            this.model.paciente = null
            this.model.condicionalidades.sexoId = null
            this.model.condicionalidades.pesoId = null
            this.model.condicionalidades.gestanteId = null
            this.model.condicionalidades.hipertensoId = null
            this.model.condicionalidades.diabeticoId = null
            this.model.condicionalidades.hanseniaseId = null
            this.model.condicionalidades.tuberculoseId = null
            this.model.condicionalidades.fumanteId = null
            this.model.condicionalidades.alcoolId = null
            this.model.condicionalidades.drogasId = null
            this.model.condicionalidades.teaId = null

            this.model.outrasDoencas.avcId = null
            this.model.outrasDoencas.infartoId = null
            this.model.outrasDoencas.cancerId = null
            this.model.outrasDoencas.fibromialgiaId = null
            this.model.outrasDoencas.internacaoId = null
            this.model.outrasDoencas.doencaCardiacaId = null
            this.model.outrasDoencas.doencaRenalId = null
            this.model.outrasDoencas.doencaRespiratoriaId = null
            this.model.outrasDoencas.tratamentoPsicologicoId = null
            this.model.outrasDoencas.plantasMedicinaisId = null
            this.model.outrasDoencas.praticasIntegrativasId = null

            this.model.atencaoDomiciliar.acamadoId = null
            this.model.atencaoDomiciliar.domiciliadoId = null

            const filter = {
                ...this.getFilter(),
                fields_to_load: [
                    'classificacao_paciente',
                    'sexo',
                    'peso',
                    'gestante',
                    'hipertenso',
                    'diabetico',
                    'hanseniase',
                    'tuberculose',
                    'fumante',
                    'alcool',
                    'drogas',
                    'tea',
                    'avc',
                    'infarto',
                    'cancer',
                    'fibromialgia',
                    'internacao',
                    'doenca_cardiaca',
                    'doenca_renal',
                    'doenca_respiratoria',
                    'tratamento_psicologico',
                    'plantas_medicinais',
                    'praticas_integrativas',
                    'acamado',
                    'domiciliado'
                ]
            }

            this.repositories.relatorioEstatisticoPacienteCadastrado.list(filter)
                .then(({ data }) => {
                    this.form.classificacaoPaciente = this.clone(data.form.classificacaoPaciente);
                    this.form.condicionalidades = this.clone(data.form.condicionalidades);
                    this.form.outrasDoencas = this.clone(data.form.outrasDoencas);
                    this.form.atencaoDomiciliar = this.clone(data.form.atencaoDomiciliar);
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        changeClassificacaoPaciente() {
            this.setLoading()
            this.items = []

            this.model.idade.anosDe = null
            this.model.idade.mesesDe = null
            this.model.idade.diasDe = null
            this.model.idade.anosAte = null
            this.model.idade.mesesAte = null
            this.model.idade.diasAte = null

            this.model.paciente = null
            this.model.condicionalidades.sexoId = null
            this.model.condicionalidades.pesoId = null
            this.model.condicionalidades.gestanteId = null
            this.model.condicionalidades.hipertensoId = null
            this.model.condicionalidades.diabeticoId = null
            this.model.condicionalidades.hanseniaseId = null
            this.model.condicionalidades.tuberculoseId = null
            this.model.condicionalidades.fumanteId = null
            this.model.condicionalidades.alcoolId = null
            this.model.condicionalidades.drogasId = null
            this.model.condicionalidades.teaId = null

            this.model.outrasDoencas.avcId = null
            this.model.outrasDoencas.infartoId = null
            this.model.outrasDoencas.cancerId = null
            this.model.outrasDoencas.fibromialgiaId = null
            this.model.outrasDoencas.internacaoId = null
            this.model.outrasDoencas.doencaCardiacaId = null
            this.model.outrasDoencas.doencaRenalId = null
            this.model.outrasDoencas.doencaRespiratoriaId = null
            this.model.outrasDoencas.tratamentoPsicologicoId = null
            this.model.outrasDoencas.plantasMedicinaisId = null
            this.model.outrasDoencas.praticasIntegrativasId = null

            this.model.atencaoDomiciliar.acamadoId = null
            this.model.atencaoDomiciliar.domiciliadoId = null

            const filter = {
                ...this.getFilter(),
                fields_to_load: [
                    'sexo',
                    'peso',
                    'gestante',
                    'hipertenso',
                    'diabetico',
                    'hanseniase',
                    'tuberculose',
                    'fumante',
                    'alcool',
                    'drogas',
                    'tea',
                    'avc',
                    'infarto',
                    'cancer',
                    'fibromialgia',
                    'internacao',
                    'doenca_cardiaca',
                    'doenca_renal',
                    'doenca_respiratoria',
                    'tratamento_psicologico',
                    'plantas_medicinais',
                    'praticas_integrativas',
                    'acamado',
                    'domiciliado'
                ]
            }

            this.repositories.relatorioEstatisticoPacienteCadastrado.list(filter)
                .then(({ data }) => {

                    this.form.condicionalidades.sexo = this.clone(data.form.condicionalidades.sexo);
                    this.form.condicionalidades.peso = this.clone(data.form.condicionalidades.peso);
                    this.form.condicionalidades.gestante = this.clone(data.form.condicionalidades.gestante);
                    this.form.condicionalidades.hipertenso = this.clone(data.form.condicionalidades.hipertenso);
                    this.form.condicionalidades.diabetico = this.clone(data.form.condicionalidades.diabetico);
                    this.form.condicionalidades.hanseniase = this.clone(data.form.condicionalidades.hanseniase);
                    this.form.condicionalidades.tuberculose = this.clone(data.form.condicionalidades.tuberculose);
                    this.form.condicionalidades.fumante = this.clone(data.form.condicionalidades.fumante);
                    this.form.condicionalidades.alcool = this.clone(data.form.condicionalidades.alcool);
                    this.form.condicionalidades.drogas = this.clone(data.form.condicionalidades.drogas);
                    this.form.condicionalidades.tea = this.clone(data.form.condicionalidades.tea);
                    this.form.outrasDoencas = this.clone(data.form.outrasDoencas);
                    this.form.atencaoDomiciliar = this.clone(data.form.atencaoDomiciliar);

                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())

        },
        changeIdadeAnosDe() {
            this.setLoading()
            this.items = []

            this.model.idade.mesesDe = null
            this.model.idade.diasDe = null
            this.model.idade.anosAte = null
            this.model.idade.mesesAte = null
            this.model.idade.diasAte = null

            this.model.paciente = null
            this.model.condicionalidades.sexoId = null
            this.model.condicionalidades.pesoId = null
            this.model.condicionalidades.gestanteId = null
            this.model.condicionalidades.hipertensoId = null
            this.model.condicionalidades.diabeticoId = null
            this.model.condicionalidades.hanseniaseId = null
            this.model.condicionalidades.tuberculoseId = null
            this.model.condicionalidades.fumanteId = null
            this.model.condicionalidades.alcoolId = null
            this.model.condicionalidades.drogasId = null
            this.model.condicionalidades.teaId = null

            this.model.outrasDoencas.avcId = null
            this.model.outrasDoencas.infartoId = null
            this.model.outrasDoencas.cancerId = null
            this.model.outrasDoencas.fibromialgiaId = null
            this.model.outrasDoencas.internacaoId = null
            this.model.outrasDoencas.doencaCardiacaId = null
            this.model.outrasDoencas.doencaRenalId = null
            this.model.outrasDoencas.doencaRespiratoriaId = null
            this.model.outrasDoencas.tratamentoPsicologicoId = null
            this.model.outrasDoencas.plantasMedicinaisId = null
            this.model.outrasDoencas.praticasIntegrativasId = null

            this.model.atencaoDomiciliar.acamadoId = null
            this.model.atencaoDomiciliar.domiciliadoId = null

            const filter = {
                ...this.getFilter(),
                fields_to_load: [
                    'sexo',
                    'peso',
                    'gestante',
                    'hipertenso',
                    'diabetico',
                    'hanseniase',
                    'tuberculose',
                    'fumante',
                    'alcool',
                    'drogas',
                    'tea',
                    'avc',
                    'infarto',
                    'cancer',
                    'fibromialgia',
                    'internacao',
                    'doenca_cardiaca',
                    'doenca_renal',
                    'doenca_respiratoria',
                    'tratamento_psicologico',
                    'plantas_medicinais',
                    'praticas_integrativas',
                    'acamado',
                    'domiciliado'
                ]
            }

            this.repositories.relatorioEstatisticoPacienteCadastrado.list(filter)
                .then(({ data }) => {
                    this.form.condicionalidades.sexo = this.clone(data.form.condicionalidades.sexo);
                    this.form.condicionalidades.peso = this.clone(data.form.condicionalidades.peso);
                    this.form.condicionalidades.gestante = this.clone(data.form.condicionalidades.gestante);
                    this.form.condicionalidades.hipertenso = this.clone(data.form.condicionalidades.hipertenso);
                    this.form.condicionalidades.diabetico = this.clone(data.form.condicionalidades.diabetico);
                    this.form.condicionalidades.hanseniase = this.clone(data.form.condicionalidades.hanseniase);
                    this.form.condicionalidades.tuberculose = this.clone(data.form.condicionalidades.tuberculose);
                    this.form.condicionalidades.fumante = this.clone(data.form.condicionalidades.fumante);
                    this.form.condicionalidades.alcool = this.clone(data.form.condicionalidades.alcool);
                    this.form.condicionalidades.drogas = this.clone(data.form.condicionalidades.drogas);
                    this.form.condicionalidades.tea = this.clone(data.form.condicionalidades.tea);
                    this.form.outrasDoencas = this.clone(data.form.outrasDoencas);
                    this.form.atencaoDomiciliar = this.clone(data.form.atencaoDomiciliar);
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        changeIdadeMesesDe() {
            this.setLoading()
            this.items = []

            this.model.idade.diasDe = null
            this.model.idade.anosAte = null
            this.model.idade.mesesAte = null
            this.model.idade.diasAte = null

            this.model.paciente = null
            this.model.condicionalidades.sexoId = null
            this.model.condicionalidades.pesoId = null
            this.model.condicionalidades.gestanteId = null
            this.model.condicionalidades.hipertensoId = null
            this.model.condicionalidades.diabeticoId = null
            this.model.condicionalidades.hanseniaseId = null
            this.model.condicionalidades.tuberculoseId = null
            this.model.condicionalidades.fumanteId = null
            this.model.condicionalidades.alcoolId = null
            this.model.condicionalidades.drogasId = null
            this.model.condicionalidades.teaId = null

            this.model.outrasDoencas.avcId = null
            this.model.outrasDoencas.infartoId = null
            this.model.outrasDoencas.cancerId = null
            this.model.outrasDoencas.fibromialgiaId = null
            this.model.outrasDoencas.internacaoId = null
            this.model.outrasDoencas.doencaCardiacaId = null
            this.model.outrasDoencas.doencaRenalId = null
            this.model.outrasDoencas.doencaRespiratoriaId = null
            this.model.outrasDoencas.tratamentoPsicologicoId = null
            this.model.outrasDoencas.plantasMedicinaisId = null
            this.model.outrasDoencas.praticasIntegrativasId = null

            this.model.atencaoDomiciliar.acamadoId = null
            this.model.atencaoDomiciliar.domiciliadoId = null

            const filter = {
                ...this.getFilter(),
                fields_to_load: [
                    'sexo',
                    'peso',
                    'gestante',
                    'hipertenso',
                    'diabetico',
                    'hanseniase',
                    'tuberculose',
                    'fumante',
                    'alcool',
                    'drogas',
                    'tea',
                    'avc',
                    'infarto',
                    'cancer',
                    'fibromialgia',
                    'internacao',
                    'doenca_cardiaca',
                    'doenca_renal',
                    'doenca_respiratoria',
                    'tratamento_psicologico',
                    'plantas_medicinais',
                    'praticas_integrativas',
                    'acamado',
                    'domiciliado'
                ]
            }

            this.repositories.relatorioEstatisticoPacienteCadastrado.list(filter)
                .then(({ data }) => {
                    this.form.condicionalidades.sexo = this.clone(data.form.condicionalidades.sexo);
                    this.form.condicionalidades.peso = this.clone(data.form.condicionalidades.peso);
                    this.form.condicionalidades.gestante = this.clone(data.form.condicionalidades.gestante);
                    this.form.condicionalidades.hipertenso = this.clone(data.form.condicionalidades.hipertenso);
                    this.form.condicionalidades.diabetico = this.clone(data.form.condicionalidades.diabetico);
                    this.form.condicionalidades.hanseniase = this.clone(data.form.condicionalidades.hanseniase);
                    this.form.condicionalidades.tuberculose = this.clone(data.form.condicionalidades.tuberculose);
                    this.form.condicionalidades.fumante = this.clone(data.form.condicionalidades.fumante);
                    this.form.condicionalidades.alcool = this.clone(data.form.condicionalidades.alcool);
                    this.form.condicionalidades.drogas = this.clone(data.form.condicionalidades.drogas);
                    this.form.condicionalidades.tea = this.clone(data.form.condicionalidades.tea);
                    this.form.outrasDoencas = this.clone(data.form.outrasDoencas);
                    this.form.atencaoDomiciliar = this.clone(data.form.atencaoDomiciliar);
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        changeIdadeDiasDe() {
            this.setLoading()
            this.items = []

            this.model.idade.anosAte = null
            this.model.idade.mesesAte = null
            this.model.idade.diasAte = null

            this.model.paciente = null
            this.model.condicionalidades.sexoId = null
            this.model.condicionalidades.pesoId = null
            this.model.condicionalidades.gestanteId = null
            this.model.condicionalidades.hipertensoId = null
            this.model.condicionalidades.diabeticoId = null
            this.model.condicionalidades.hanseniaseId = null
            this.model.condicionalidades.tuberculoseId = null
            this.model.condicionalidades.fumanteId = null
            this.model.condicionalidades.alcoolId = null
            this.model.condicionalidades.drogasId = null
            this.model.condicionalidades.teaId = null

            this.model.outrasDoencas.avcId = null
            this.model.outrasDoencas.infartoId = null
            this.model.outrasDoencas.cancerId = null
            this.model.outrasDoencas.fibromialgiaId = null
            this.model.outrasDoencas.internacaoId = null
            this.model.outrasDoencas.doencaCardiacaId = null
            this.model.outrasDoencas.doencaRenalId = null
            this.model.outrasDoencas.doencaRespiratoriaId = null
            this.model.outrasDoencas.tratamentoPsicologicoId = null
            this.model.outrasDoencas.plantasMedicinaisId = null
            this.model.outrasDoencas.praticasIntegrativasId = null

            this.model.atencaoDomiciliar.acamadoId = null
            this.model.atencaoDomiciliar.domiciliadoId = null

            const filter = {
                ...this.getFilter(),
                fields_to_load: [
                    'sexo',
                    'peso',
                    'gestante',
                    'hipertenso',
                    'diabetico',
                    'hanseniase',
                    'tuberculose',
                    'fumante',
                    'alcool',
                    'drogas',
                    'tea',
                    'avc',
                    'infarto',
                    'cancer',
                    'fibromialgia',
                    'internacao',
                    'doenca_cardiaca',
                    'doenca_renal',
                    'doenca_respiratoria',
                    'tratamento_psicologico',
                    'plantas_medicinais',
                    'praticas_integrativas',
                    'acamado',
                    'domiciliado'
                ]
            }

            this.repositories.relatorioEstatisticoPacienteCadastrado.list(filter)
                .then(({ data }) => {
                    this.form.condicionalidades.sexo = this.clone(data.form.condicionalidades.sexo);
                    this.form.condicionalidades.peso = this.clone(data.form.condicionalidades.peso);
                    this.form.condicionalidades.gestante = this.clone(data.form.condicionalidades.gestante);
                    this.form.condicionalidades.hipertenso = this.clone(data.form.condicionalidades.hipertenso);
                    this.form.condicionalidades.diabetico = this.clone(data.form.condicionalidades.diabetico);
                    this.form.condicionalidades.hanseniase = this.clone(data.form.condicionalidades.hanseniase);
                    this.form.condicionalidades.tuberculose = this.clone(data.form.condicionalidades.tuberculose);
                    this.form.condicionalidades.fumante = this.clone(data.form.condicionalidades.fumante);
                    this.form.condicionalidades.alcool = this.clone(data.form.condicionalidades.alcool);
                    this.form.condicionalidades.drogas = this.clone(data.form.condicionalidades.drogas);
                    this.form.condicionalidades.tea = this.clone(data.form.condicionalidades.tea);
                    this.form.outrasDoencas = this.clone(data.form.outrasDoencas);
                    this.form.atencaoDomiciliar = this.clone(data.form.atencaoDomiciliar);
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        changeIdadeAnosAte() {
            this.setLoading()
            this.items = []

            this.model.idade.mesesAte = null
            this.model.idade.diasAte = null

            this.model.paciente = null
            this.model.condicionalidades.sexoId = null
            this.model.condicionalidades.pesoId = null
            this.model.condicionalidades.gestanteId = null
            this.model.condicionalidades.hipertensoId = null
            this.model.condicionalidades.diabeticoId = null
            this.model.condicionalidades.hanseniaseId = null
            this.model.condicionalidades.tuberculoseId = null
            this.model.condicionalidades.fumanteId = null
            this.model.condicionalidades.alcoolId = null
            this.model.condicionalidades.drogasId = null
            this.model.condicionalidades.teaId = null

            this.model.outrasDoencas.avcId = null
            this.model.outrasDoencas.infartoId = null
            this.model.outrasDoencas.cancerId = null
            this.model.outrasDoencas.fibromialgiaId = null
            this.model.outrasDoencas.internacaoId = null
            this.model.outrasDoencas.doencaCardiacaId = null
            this.model.outrasDoencas.doencaRenalId = null
            this.model.outrasDoencas.doencaRespiratoriaId = null
            this.model.outrasDoencas.tratamentoPsicologicoId = null
            this.model.outrasDoencas.plantasMedicinaisId = null
            this.model.outrasDoencas.praticasIntegrativasId = null

            this.model.atencaoDomiciliar.acamadoId = null
            this.model.atencaoDomiciliar.domiciliadoId = null

            const filter = {
                ...this.getFilter(),
                fields_to_load: [
                    'sexo',
                    'peso',
                    'gestante',
                    'hipertenso',
                    'diabetico',
                    'hanseniase',
                    'tuberculose',
                    'fumante',
                    'alcool',
                    'drogas',
                    'tea',
                    'avc',
                    'infarto',
                    'cancer',
                    'fibromialgia',
                    'internacao',
                    'doenca_cardiaca',
                    'doenca_renal',
                    'doenca_respiratoria',
                    'tratamento_psicologico',
                    'plantas_medicinais',
                    'praticas_integrativas',
                    'acamado',
                    'domiciliado'
                ]
            }

            this.repositories.relatorioEstatisticoPacienteCadastrado.list(filter)
                .then(({ data }) => {
                    this.form.condicionalidades.sexo = this.clone(data.form.condicionalidades.sexo);
                    this.form.condicionalidades.peso = this.clone(data.form.condicionalidades.peso);
                    this.form.condicionalidades.gestante = this.clone(data.form.condicionalidades.gestante);
                    this.form.condicionalidades.hipertenso = this.clone(data.form.condicionalidades.hipertenso);
                    this.form.condicionalidades.diabetico = this.clone(data.form.condicionalidades.diabetico);
                    this.form.condicionalidades.hanseniase = this.clone(data.form.condicionalidades.hanseniase);
                    this.form.condicionalidades.tuberculose = this.clone(data.form.condicionalidades.tuberculose);
                    this.form.condicionalidades.fumante = this.clone(data.form.condicionalidades.fumante);
                    this.form.condicionalidades.alcool = this.clone(data.form.condicionalidades.alcool);
                    this.form.condicionalidades.drogas = this.clone(data.form.condicionalidades.drogas);
                    this.form.condicionalidades.tea = this.clone(data.form.condicionalidades.tea);
                    this.form.outrasDoencas = this.clone(data.form.outrasDoencas);
                    this.form.atencaoDomiciliar = this.clone(data.form.atencaoDomiciliar);
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())

        },
        changeIdadeMesesAte() {
            this.setLoading()
            this.items = []

            this.model.idade.diasAte = null

            this.model.paciente = null
            this.model.condicionalidades.sexoId = null
            this.model.condicionalidades.pesoId = null
            this.model.condicionalidades.gestanteId = null
            this.model.condicionalidades.hipertensoId = null
            this.model.condicionalidades.diabeticoId = null
            this.model.condicionalidades.hanseniaseId = null
            this.model.condicionalidades.tuberculoseId = null
            this.model.condicionalidades.fumanteId = null
            this.model.condicionalidades.alcoolId = null
            this.model.condicionalidades.drogasId = null
            this.model.condicionalidades.teaId = null

            this.model.outrasDoencas.avcId = null
            this.model.outrasDoencas.infartoId = null
            this.model.outrasDoencas.cancerId = null
            this.model.outrasDoencas.fibromialgiaId = null
            this.model.outrasDoencas.internacaoId = null
            this.model.outrasDoencas.doencaCardiacaId = null
            this.model.outrasDoencas.doencaRenalId = null
            this.model.outrasDoencas.doencaRespiratoriaId = null
            this.model.outrasDoencas.tratamentoPsicologicoId = null
            this.model.outrasDoencas.plantasMedicinaisId = null
            this.model.outrasDoencas.praticasIntegrativasId = null

            this.model.atencaoDomiciliar.acamadoId = null
            this.model.atencaoDomiciliar.domiciliadoId = null

            const filter = {
                ...this.getFilter(),
                fields_to_load: [
                    'sexo',
                    'peso',
                    'gestante',
                    'hipertenso',
                    'diabetico',
                    'hanseniase',
                    'tuberculose',
                    'fumante',
                    'alcool',
                    'drogas',
                    'tea',
                    'avc',
                    'infarto',
                    'cancer',
                    'fibromialgia',
                    'internacao',
                    'doenca_cardiaca',
                    'doenca_renal',
                    'doenca_respiratoria',
                    'tratamento_psicologico',
                    'plantas_medicinais',
                    'praticas_integrativas',
                    'acamado',
                    'domiciliado'
                ]
            }

            this.repositories.relatorioEstatisticoPacienteCadastrado.list(filter)
                .then(({ data }) => {
                    this.form.condicionalidades.sexo = this.clone(data.form.condicionalidades.sexo);
                    this.form.condicionalidades.peso = this.clone(data.form.condicionalidades.peso);
                    this.form.condicionalidades.gestante = this.clone(data.form.condicionalidades.gestante);
                    this.form.condicionalidades.hipertenso = this.clone(data.form.condicionalidades.hipertenso);
                    this.form.condicionalidades.diabetico = this.clone(data.form.condicionalidades.diabetico);
                    this.form.condicionalidades.hanseniase = this.clone(data.form.condicionalidades.hanseniase);
                    this.form.condicionalidades.tuberculose = this.clone(data.form.condicionalidades.tuberculose);
                    this.form.condicionalidades.fumante = this.clone(data.form.condicionalidades.fumante);
                    this.form.condicionalidades.alcool = this.clone(data.form.condicionalidades.alcool);
                    this.form.condicionalidades.drogas = this.clone(data.form.condicionalidades.drogas);
                    this.form.condicionalidades.tea = this.clone(data.form.condicionalidades.tea);
                    this.form.outrasDoencas = this.clone(data.form.outrasDoencas);
                    this.form.atencaoDomiciliar = this.clone(data.form.atencaoDomiciliar);
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        changeIdadeDiasAte() {
            this.setLoading()
            this.items = []

            this.model.paciente = null
            this.model.condicionalidades.sexoId = null
            this.model.condicionalidades.pesoId = null
            this.model.condicionalidades.gestanteId = null
            this.model.condicionalidades.hipertensoId = null
            this.model.condicionalidades.diabeticoId = null
            this.model.condicionalidades.hanseniaseId = null
            this.model.condicionalidades.tuberculoseId = null
            this.model.condicionalidades.fumanteId = null
            this.model.condicionalidades.alcoolId = null
            this.model.condicionalidades.drogasId = null
            this.model.condicionalidades.teaId = null

            this.model.outrasDoencas.avcId = null
            this.model.outrasDoencas.infartoId = null
            this.model.outrasDoencas.cancerId = null
            this.model.outrasDoencas.fibromialgiaId = null
            this.model.outrasDoencas.internacaoId = null
            this.model.outrasDoencas.doencaCardiacaId = null
            this.model.outrasDoencas.doencaRenalId = null
            this.model.outrasDoencas.doencaRespiratoriaId = null
            this.model.outrasDoencas.tratamentoPsicologicoId = null
            this.model.outrasDoencas.plantasMedicinaisId = null
            this.model.outrasDoencas.praticasIntegrativasId = null

            this.model.atencaoDomiciliar.acamadoId = null
            this.model.atencaoDomiciliar.domiciliadoId = null

            const filter = {
                ...this.getFilter(),
                fields_to_load: [
                    'sexo',
                    'peso',
                    'gestante',
                    'hipertenso',
                    'diabetico',
                    'hanseniase',
                    'tuberculose',
                    'fumante',
                    'alcool',
                    'drogas',
                    'tea',
                    'avc',
                    'infarto',
                    'cancer',
                    'fibromialgia',
                    'internacao',
                    'doenca_cardiaca',
                    'doenca_renal',
                    'doenca_respiratoria',
                    'tratamento_psicologico',
                    'plantas_medicinais',
                    'praticas_integrativas',
                    'acamado',
                    'domiciliado'
                ]
            }

            this.repositories.relatorioEstatisticoPacienteCadastrado.list(filter)
                .then(({ data }) => {
                    this.form.condicionalidades.sexo = this.clone(data.form.condicionalidades.sexo);
                    this.form.condicionalidades.peso = this.clone(data.form.condicionalidades.peso);
                    this.form.condicionalidades.gestante = this.clone(data.form.condicionalidades.gestante);
                    this.form.condicionalidades.hipertenso = this.clone(data.form.condicionalidades.hipertenso);
                    this.form.condicionalidades.diabetico = this.clone(data.form.condicionalidades.diabetico);
                    this.form.condicionalidades.hanseniase = this.clone(data.form.condicionalidades.hanseniase);
                    this.form.condicionalidades.tuberculose = this.clone(data.form.condicionalidades.tuberculose);
                    this.form.condicionalidades.fumante = this.clone(data.form.condicionalidades.fumante);
                    this.form.condicionalidades.alcool = this.clone(data.form.condicionalidades.alcool);
                    this.form.condicionalidades.drogas = this.clone(data.form.condicionalidades.drogas);
                    this.form.condicionalidades.tea = this.clone(data.form.condicionalidades.tea);
                    this.form.outrasDoencas = this.clone(data.form.outrasDoencas);
                    this.form.atencaoDomiciliar = this.clone(data.form.atencaoDomiciliar);
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        changePaciente() {
            this.setLoading()
            this.items = []

            this.model.condicionalidades.sexoId = null
            this.model.condicionalidades.pesoId = null
            this.model.condicionalidades.gestanteId = null
            this.model.condicionalidades.hipertensoId = null
            this.model.condicionalidades.diabeticoId = null
            this.model.condicionalidades.hanseniaseId = null
            this.model.condicionalidades.tuberculoseId = null
            this.model.condicionalidades.fumanteId = null
            this.model.condicionalidades.alcoolId = null
            this.model.condicionalidades.drogasId = null
            this.model.condicionalidades.teaId = null

            this.model.outrasDoencas.avcId = null
            this.model.outrasDoencas.infartoId = null
            this.model.outrasDoencas.cancerId = null
            this.model.outrasDoencas.fibromialgiaId = null
            this.model.outrasDoencas.internacaoId = null
            this.model.outrasDoencas.doencaCardiacaId = null
            this.model.outrasDoencas.doencaRenalId = null
            this.model.outrasDoencas.doencaRespiratoriaId = null
            this.model.outrasDoencas.tratamentoPsicologicoId = null
            this.model.outrasDoencas.plantasMedicinaisId = null
            this.model.outrasDoencas.praticasIntegrativasId = null

            this.model.atencaoDomiciliar.acamadoId = null
            this.model.atencaoDomiciliar.domiciliadoId = null

            const filter = {
                ...this.getFilter(),
                fields_to_load: [
                    'sexo',
                    'peso',
                    'gestante',
                    'hipertenso',
                    'diabetico',
                    'hanseniase',
                    'tuberculose',
                    'fumante',
                    'alcool',
                    'drogas',
                    'tea',
                    'avc',
                    'infarto',
                    'cancer',
                    'fibromialgia',
                    'internacao',
                    'doenca_cardiaca',
                    'doenca_renal',
                    'doenca_respiratoria',
                    'tratamento_psicologico',
                    'plantas_medicinais',
                    'praticas_integrativas',
                    'acamado',
                    'domiciliado'
                ]
            }

            this.repositories.relatorioEstatisticoPacienteCadastrado.list(filter)
                .then(({ data }) => {
                    this.form.condicionalidades.sexo = this.clone(data.form.condicionalidades.sexo);
                    this.form.condicionalidades.peso = this.clone(data.form.condicionalidades.peso);
                    this.form.condicionalidades.gestante = this.clone(data.form.condicionalidades.gestante);
                    this.form.condicionalidades.hipertenso = this.clone(data.form.condicionalidades.hipertenso);
                    this.form.condicionalidades.diabetico = this.clone(data.form.condicionalidades.diabetico);
                    this.form.condicionalidades.hanseniase = this.clone(data.form.condicionalidades.hanseniase);
                    this.form.condicionalidades.tuberculose = this.clone(data.form.condicionalidades.tuberculose);
                    this.form.condicionalidades.fumante = this.clone(data.form.condicionalidades.fumante);
                    this.form.condicionalidades.alcool = this.clone(data.form.condicionalidades.alcool);
                    this.form.condicionalidades.drogas = this.clone(data.form.condicionalidades.drogas);
                    this.form.condicionalidades.tea = this.clone(data.form.condicionalidades.tea);
                    this.form.outrasDoencas = this.clone(data.form.outrasDoencas);
                    this.form.atencaoDomiciliar = this.clone(data.form.atencaoDomiciliar);
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        changeCondicionalidadesSexo() {
            this.setLoading()
            this.items = []

            this.model.condicionalidades.pesoId = null
            this.model.condicionalidades.gestanteId = null
            this.model.condicionalidades.hipertensoId = null
            this.model.condicionalidades.diabeticoId = null
            this.model.condicionalidades.hanseniaseId = null
            this.model.condicionalidades.tuberculoseId = null
            this.model.condicionalidades.fumanteId = null
            this.model.condicionalidades.alcoolId = null
            this.model.condicionalidades.drogasId = null
            this.model.condicionalidades.teaId = null

            this.model.outrasDoencas.avcId = null
            this.model.outrasDoencas.infartoId = null
            this.model.outrasDoencas.cancerId = null
            this.model.outrasDoencas.fibromialgiaId = null
            this.model.outrasDoencas.internacaoId = null
            this.model.outrasDoencas.doencaCardiacaId = null
            this.model.outrasDoencas.doencaRenalId = null
            this.model.outrasDoencas.doencaRespiratoriaId = null
            this.model.outrasDoencas.tratamentoPsicologicoId = null
            this.model.outrasDoencas.plantasMedicinaisId = null
            this.model.outrasDoencas.praticasIntegrativasId = null

            this.model.atencaoDomiciliar.acamadoId = null
            this.model.atencaoDomiciliar.domiciliadoId = null

            const filter = {
                ...this.getFilter(),
                fields_to_load: [
                    'peso',
                    'gestante',
                    'hipertenso',
                    'diabetico',
                    'hanseniase',
                    'tuberculose',
                    'fumante',
                    'alcool',
                    'drogas',
                    'tea',
                    'avc',
                    'infarto',
                    'cancer',
                    'fibromialgia',
                    'internacao',
                    'doenca_cardiaca',
                    'doenca_renal',
                    'doenca_respiratoria',
                    'tratamento_psicologico',
                    'plantas_medicinais',
                    'praticas_integrativas',
                    'acamado',
                    'domiciliado'
                ]
            }

            this.repositories.relatorioEstatisticoPacienteCadastrado.list(filter)
                .then(({ data }) => {
                    this.form.condicionalidades.peso = this.clone(data.form.condicionalidades.peso);
                    this.form.condicionalidades.gestante = this.clone(data.form.condicionalidades.gestante);
                    this.form.condicionalidades.hipertenso = this.clone(data.form.condicionalidades.hipertenso);
                    this.form.condicionalidades.diabetico = this.clone(data.form.condicionalidades.diabetico);
                    this.form.condicionalidades.hanseniase = this.clone(data.form.condicionalidades.hanseniase);
                    this.form.condicionalidades.tuberculose = this.clone(data.form.condicionalidades.tuberculose);
                    this.form.condicionalidades.fumante = this.clone(data.form.condicionalidades.fumante);
                    this.form.condicionalidades.alcool = this.clone(data.form.condicionalidades.alcool);
                    this.form.condicionalidades.drogas = this.clone(data.form.condicionalidades.drogas);
                    this.form.condicionalidades.tea = this.clone(data.form.condicionalidades.tea);
                    this.form.outrasDoencas = this.clone(data.form.outrasDoencas);
                    this.form.atencaoDomiciliar = this.clone(data.form.atencaoDomiciliar);
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        changeCondicionalidadesPeso() {
            this.setLoading()
            this.items = []

            this.model.condicionalidades.gestanteId = null
            this.model.condicionalidades.hipertensoId = null
            this.model.condicionalidades.diabeticoId = null
            this.model.condicionalidades.hanseniaseId = null
            this.model.condicionalidades.tuberculoseId = null
            this.model.condicionalidades.fumanteId = null
            this.model.condicionalidades.alcoolId = null
            this.model.condicionalidades.drogasId = null
            this.model.condicionalidades.teaId = null

            this.model.outrasDoencas.avcId = null
            this.model.outrasDoencas.infartoId = null
            this.model.outrasDoencas.cancerId = null
            this.model.outrasDoencas.fibromialgiaId = null
            this.model.outrasDoencas.internacaoId = null
            this.model.outrasDoencas.doencaCardiacaId = null
            this.model.outrasDoencas.doencaRenalId = null
            this.model.outrasDoencas.doencaRespiratoriaId = null
            this.model.outrasDoencas.tratamentoPsicologicoId = null
            this.model.outrasDoencas.plantasMedicinaisId = null
            this.model.outrasDoencas.praticasIntegrativasId = null

            this.model.atencaoDomiciliar.acamadoId = null
            this.model.atencaoDomiciliar.domiciliadoId = null

            const filter = {
                ...this.getFilter(),
                fields_to_load: [
                    'gestante',
                    'hipertenso',
                    'diabetico',
                    'hanseniase',
                    'tuberculose',
                    'fumante',
                    'alcool',
                    'drogas',
                    'tea',
                    'avc',
                    'infarto',
                    'cancer',
                    'fibromialgia',
                    'internacao',
                    'doenca_cardiaca',
                    'doenca_renal',
                    'doenca_respiratoria',
                    'tratamento_psicologico',
                    'plantas_medicinais',
                    'praticas_integrativas',
                    'acamado',
                    'domiciliado'
                ]
            }

            this.repositories.relatorioEstatisticoPacienteCadastrado.list(filter)
                .then(({ data }) => {
                    this.form.condicionalidades.gestante = this.clone(data.form.condicionalidades.gestante);
                    this.form.condicionalidades.hipertenso = this.clone(data.form.condicionalidades.hipertenso);
                    this.form.condicionalidades.diabetico = this.clone(data.form.condicionalidades.diabetico);
                    this.form.condicionalidades.hanseniase = this.clone(data.form.condicionalidades.hanseniase);
                    this.form.condicionalidades.tuberculose = this.clone(data.form.condicionalidades.tuberculose);
                    this.form.condicionalidades.fumante = this.clone(data.form.condicionalidades.fumante);
                    this.form.condicionalidades.alcool = this.clone(data.form.condicionalidades.alcool);
                    this.form.condicionalidades.drogas = this.clone(data.form.condicionalidades.drogas);
                    this.form.condicionalidades.tea = this.clone(data.form.condicionalidades.tea);
                    this.form.outrasDoencas = this.clone(data.form.outrasDoencas);
                    this.form.atencaoDomiciliar = this.clone(data.form.atencaoDomiciliar);
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        changeCondicionalidadesGestante() {
            this.setLoading()
            this.items = []

            this.model.condicionalidades.hipertensoId = null
            this.model.condicionalidades.diabeticoId = null
            this.model.condicionalidades.hanseniaseId = null
            this.model.condicionalidades.tuberculoseId = null
            this.model.condicionalidades.fumanteId = null
            this.model.condicionalidades.alcoolId = null
            this.model.condicionalidades.drogasId = null
            this.model.condicionalidades.teaId = null

            this.model.outrasDoencas.avcId = null
            this.model.outrasDoencas.infartoId = null
            this.model.outrasDoencas.cancerId = null
            this.model.outrasDoencas.fibromialgiaId = null
            this.model.outrasDoencas.internacaoId = null
            this.model.outrasDoencas.doencaCardiacaId = null
            this.model.outrasDoencas.doencaRenalId = null
            this.model.outrasDoencas.doencaRespiratoriaId = null
            this.model.outrasDoencas.tratamentoPsicologicoId = null
            this.model.outrasDoencas.plantasMedicinaisId = null
            this.model.outrasDoencas.praticasIntegrativasId = null

            this.model.atencaoDomiciliar.acamadoId = null
            this.model.atencaoDomiciliar.domiciliadoId = null

            const filter = {
                ...this.getFilter(),
                fields_to_load: [
                    'hipertenso',
                    'diabetico',
                    'hanseniase',
                    'tuberculose',
                    'fumante',
                    'alcool',
                    'drogas',
                    'tea',
                    'avc',
                    'infarto',
                    'cancer',
                    'fibromialgia',
                    'internacao',
                    'doenca_cardiaca',
                    'doenca_renal',
                    'doenca_respiratoria',
                    'tratamento_psicologico',
                    'plantas_medicinais',
                    'praticas_integrativas',
                    'acamado',
                    'domiciliado'
                ]
            }

            this.repositories.relatorioEstatisticoPacienteCadastrado.list(filter)
                .then(({ data }) => {
                    this.form.condicionalidades.hipertenso = this.clone(data.form.condicionalidades.hipertenso);
                    this.form.condicionalidades.diabetico = this.clone(data.form.condicionalidades.diabetico);
                    this.form.condicionalidades.hanseniase = this.clone(data.form.condicionalidades.hanseniase);
                    this.form.condicionalidades.tuberculose = this.clone(data.form.condicionalidades.tuberculose);
                    this.form.condicionalidades.fumante = this.clone(data.form.condicionalidades.fumante);
                    this.form.condicionalidades.alcool = this.clone(data.form.condicionalidades.alcool);
                    this.form.condicionalidades.drogas = this.clone(data.form.condicionalidades.drogas);
                    this.form.condicionalidades.tea = this.clone(data.form.condicionalidades.tea);
                    this.form.outrasDoencas = this.clone(data.form.outrasDoencas);
                    this.form.atencaoDomiciliar = this.clone(data.form.atencaoDomiciliar);
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        changeCondicionalidadesHipertenso() {
            this.setLoading()
            this.items = []

            this.model.condicionalidades.diabeticoId = null
            this.model.condicionalidades.hanseniaseId = null
            this.model.condicionalidades.tuberculoseId = null
            this.model.condicionalidades.fumanteId = null
            this.model.condicionalidades.alcoolId = null
            this.model.condicionalidades.drogasId = null
            this.model.condicionalidades.teaId = null

            this.model.outrasDoencas.avcId = null
            this.model.outrasDoencas.infartoId = null
            this.model.outrasDoencas.cancerId = null
            this.model.outrasDoencas.fibromialgiaId = null
            this.model.outrasDoencas.internacaoId = null
            this.model.outrasDoencas.doencaCardiacaId = null
            this.model.outrasDoencas.doencaRenalId = null
            this.model.outrasDoencas.doencaRespiratoriaId = null
            this.model.outrasDoencas.tratamentoPsicologicoId = null
            this.model.outrasDoencas.plantasMedicinaisId = null
            this.model.outrasDoencas.praticasIntegrativasId = null

            this.model.atencaoDomiciliar.acamadoId = null
            this.model.atencaoDomiciliar.domiciliadoId = null

            const filter = {
                ...this.getFilter(),
                fields_to_load: [
                    'diabetico',
                    'hanseniase',
                    'tuberculose',
                    'fumante',
                    'alcool',
                    'drogas',
                    'tea',
                    'avc',
                    'infarto',
                    'cancer',
                    'fibromialgia',
                    'internacao',
                    'doenca_cardiaca',
                    'doenca_renal',
                    'doenca_respiratoria',
                    'tratamento_psicologico',
                    'plantas_medicinais',
                    'praticas_integrativas',
                    'acamado',
                    'domiciliado'
                ]
            }

            this.repositories.relatorioEstatisticoPacienteCadastrado.list(filter)
                .then(({ data }) => {
                    this.form.condicionalidades.diabetico = this.clone(data.form.condicionalidades.diabetico);
                    this.form.condicionalidades.hanseniase = this.clone(data.form.condicionalidades.hanseniase);
                    this.form.condicionalidades.tuberculose = this.clone(data.form.condicionalidades.tuberculose);
                    this.form.condicionalidades.fumante = this.clone(data.form.condicionalidades.fumante);
                    this.form.condicionalidades.alcool = this.clone(data.form.condicionalidades.alcool);
                    this.form.condicionalidades.drogas = this.clone(data.form.condicionalidades.drogas);
                    this.form.condicionalidades.tea = this.clone(data.form.condicionalidades.tea);
                    this.form.outrasDoencas = this.clone(data.form.outrasDoencas);
                    this.form.atencaoDomiciliar = this.clone(data.form.atencaoDomiciliar);
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        changeCondicionalidadesDiabetico() {
            this.setLoading()
            this.items = []

            this.model.condicionalidades.hanseniaseId = null
            this.model.condicionalidades.tuberculoseId = null
            this.model.condicionalidades.fumanteId = null
            this.model.condicionalidades.alcoolId = null
            this.model.condicionalidades.drogasId = null
            this.model.condicionalidades.teaId = null

            this.model.outrasDoencas.avcId = null
            this.model.outrasDoencas.infartoId = null
            this.model.outrasDoencas.cancerId = null
            this.model.outrasDoencas.fibromialgiaId = null
            this.model.outrasDoencas.internacaoId = null
            this.model.outrasDoencas.doencaCardiacaId = null
            this.model.outrasDoencas.doencaRenalId = null
            this.model.outrasDoencas.doencaRespiratoriaId = null
            this.model.outrasDoencas.tratamentoPsicologicoId = null
            this.model.outrasDoencas.plantasMedicinaisId = null
            this.model.outrasDoencas.praticasIntegrativasId = null

            this.model.atencaoDomiciliar.acamadoId = null
            this.model.atencaoDomiciliar.domiciliadoId = null

            const filter = {
                ...this.getFilter(),
                fields_to_load: [
                    'hanseniase',
                    'tuberculose',
                    'fumante',
                    'alcool',
                    'drogas',
                    'tea',
                    'avc',
                    'infarto',
                    'cancer',
                    'fibromialgia',
                    'internacao',
                    'doenca_cardiaca',
                    'doenca_renal',
                    'doenca_respiratoria',
                    'tratamento_psicologico',
                    'plantas_medicinais',
                    'praticas_integrativas',
                    'acamado',
                    'domiciliado'
                ]
            }

            this.repositories.relatorioEstatisticoPacienteCadastrado.list(filter)
                .then(({ data }) => {
                    this.form.condicionalidades.hanseniase = this.clone(data.form.condicionalidades.hanseniase);
                    this.form.condicionalidades.tuberculose = this.clone(data.form.condicionalidades.tuberculose);
                    this.form.condicionalidades.fumante = this.clone(data.form.condicionalidades.fumante);
                    this.form.condicionalidades.alcool = this.clone(data.form.condicionalidades.alcool);
                    this.form.condicionalidades.drogas = this.clone(data.form.condicionalidades.drogas);
                    this.form.condicionalidades.tea = this.clone(data.form.condicionalidades.tea);
                    this.form.outrasDoencas = this.clone(data.form.outrasDoencas);
                    this.form.atencaoDomiciliar = this.clone(data.form.atencaoDomiciliar);
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        changeCondicionalidadeshanseniase() {
            this.setLoading()
            this.items = []

            this.model.condicionalidades.tuberculoseId = null
            this.model.condicionalidades.fumanteId = null
            this.model.condicionalidades.alcoolId = null
            this.model.condicionalidades.drogasId = null
            this.model.condicionalidades.teaId = null

            this.model.outrasDoencas.avcId = null
            this.model.outrasDoencas.infartoId = null
            this.model.outrasDoencas.cancerId = null
            this.model.outrasDoencas.fibromialgiaId = null
            this.model.outrasDoencas.internacaoId = null
            this.model.outrasDoencas.doencaCardiacaId = null
            this.model.outrasDoencas.doencaRenalId = null
            this.model.outrasDoencas.doencaRespiratoriaId = null
            this.model.outrasDoencas.tratamentoPsicologicoId = null
            this.model.outrasDoencas.plantasMedicinaisId = null
            this.model.outrasDoencas.praticasIntegrativasId = null

            this.model.atencaoDomiciliar.acamadoId = null
            this.model.atencaoDomiciliar.domiciliadoId = null

            const filter = {
                ...this.getFilter(),
                fields_to_load: [
                    'tuberculose',
                    'fumante',
                    'alcool',
                    'drogas',
                    'tea',
                    'avc',
                    'infarto',
                    'cancer',
                    'fibromialgia',
                    'internacao',
                    'doenca_cardiaca',
                    'doenca_renal',
                    'doenca_respiratoria',
                    'tratamento_psicologico',
                    'plantas_medicinais',
                    'praticas_integrativas',
                    'acamado',
                    'domiciliado'
                ]
            }

            this.repositories.relatorioEstatisticoPacienteCadastrado.list(filter)
                .then(({ data }) => {
                    this.form.condicionalidades.tuberculose = this.clone(data.form.condicionalidades.tuberculose);
                    this.form.condicionalidades.fumante = this.clone(data.form.condicionalidades.fumante);
                    this.form.condicionalidades.alcool = this.clone(data.form.condicionalidades.alcool);
                    this.form.condicionalidades.drogas = this.clone(data.form.condicionalidades.drogas);
                    this.form.condicionalidades.tea = this.clone(data.form.condicionalidades.tea);
                    this.form.outrasDoencas = this.clone(data.form.outrasDoencas);
                    this.form.atencaoDomiciliar = this.clone(data.form.atencaoDomiciliar);
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        changeCondicionalidadesTuberculose() {
            this.setLoading()
            this.items = []

            this.model.condicionalidades.fumanteId = null
            this.model.condicionalidades.alcoolId = null
            this.model.condicionalidades.drogasId = null
            this.model.condicionalidades.teaId = null

            this.model.outrasDoencas.avcId = null
            this.model.outrasDoencas.infartoId = null
            this.model.outrasDoencas.cancerId = null
            this.model.outrasDoencas.fibromialgiaId = null
            this.model.outrasDoencas.internacaoId = null
            this.model.outrasDoencas.doencaCardiacaId = null
            this.model.outrasDoencas.doencaRenalId = null
            this.model.outrasDoencas.doencaRespiratoriaId = null
            this.model.outrasDoencas.tratamentoPsicologicoId = null
            this.model.outrasDoencas.plantasMedicinaisId = null
            this.model.outrasDoencas.praticasIntegrativasId = null

            this.model.atencaoDomiciliar.acamadoId = null
            this.model.atencaoDomiciliar.domiciliadoId = null

            const filter = {
                ...this.getFilter(),
                fields_to_load: [
                    'fumante',
                    'alcool',
                    'drogas',
                    'tea',
                    'avc',
                    'infarto',
                    'cancer',
                    'fibromialgia',
                    'internacao',
                    'doenca_cardiaca',
                    'doenca_renal',
                    'doenca_respiratoria',
                    'tratamento_psicologico',
                    'plantas_medicinais',
                    'praticas_integrativas',
                    'acamado',
                    'domiciliado'
                ]
            }

            this.repositories.relatorioEstatisticoPacienteCadastrado.list(filter)
                .then(({ data }) => {
                    this.form.condicionalidades.fumante = this.clone(data.form.condicionalidades.fumante);
                    this.form.condicionalidades.alcool = this.clone(data.form.condicionalidades.alcool);
                    this.form.condicionalidades.drogas = this.clone(data.form.condicionalidades.drogas);
                    this.form.condicionalidades.tea = this.clone(data.form.condicionalidades.tea);
                    this.form.outrasDoencas = this.clone(data.form.outrasDoencas);
                    this.form.atencaoDomiciliar = this.clone(data.form.atencaoDomiciliar);
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        changeCondicionalidadesFumante() {
            this.setLoading()
            this.items = []

            this.model.condicionalidades.alcoolId = null
            this.model.condicionalidades.drogasId = null
            this.model.condicionalidades.teaId = null

            this.model.outrasDoencas.avcId = null
            this.model.outrasDoencas.infartoId = null
            this.model.outrasDoencas.cancerId = null
            this.model.outrasDoencas.fibromialgiaId = null
            this.model.outrasDoencas.internacaoId = null
            this.model.outrasDoencas.doencaCardiacaId = null
            this.model.outrasDoencas.doencaRenalId = null
            this.model.outrasDoencas.doencaRespiratoriaId = null
            this.model.outrasDoencas.tratamentoPsicologicoId = null
            this.model.outrasDoencas.plantasMedicinaisId = null
            this.model.outrasDoencas.praticasIntegrativasId = null

            this.model.atencaoDomiciliar.acamadoId = null
            this.model.atencaoDomiciliar.domiciliadoId = null

            const filter = {
                ...this.getFilter(),
                fields_to_load: [
                    'alcool',
                    'drogas',
                    'tea',
                    'avc',
                    'infarto',
                    'cancer',
                    'fibromialgia',
                    'internacao',
                    'doenca_cardiaca',
                    'doenca_renal',
                    'doenca_respiratoria',
                    'tratamento_psicologico',
                    'plantas_medicinais',
                    'praticas_integrativas',
                    'acamado',
                    'domiciliado'
                ]
            }

            this.repositories.relatorioEstatisticoPacienteCadastrado.list(filter)
                .then(({ data }) => {
                    this.form.condicionalidades.alcool = this.clone(data.form.condicionalidades.alcool);
                    this.form.condicionalidades.drogas = this.clone(data.form.condicionalidades.drogas);
                    this.form.condicionalidades.tea = this.clone(data.form.condicionalidades.tea);
                    this.form.outrasDoencas = this.clone(data.form.outrasDoencas);
                    this.form.atencaoDomiciliar = this.clone(data.form.atencaoDomiciliar);
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        changeCondicionalidadesAlcool() {
            this.setLoading()
            this.items = []

            this.model.condicionalidades.drogasId = null
            this.model.condicionalidades.teaId = null

            this.model.outrasDoencas.avcId = null
            this.model.outrasDoencas.infartoId = null
            this.model.outrasDoencas.cancerId = null
            this.model.outrasDoencas.fibromialgiaId = null
            this.model.outrasDoencas.internacaoId = null
            this.model.outrasDoencas.doencaCardiacaId = null
            this.model.outrasDoencas.doencaRenalId = null
            this.model.outrasDoencas.doencaRespiratoriaId = null
            this.model.outrasDoencas.tratamentoPsicologicoId = null
            this.model.outrasDoencas.plantasMedicinaisId = null
            this.model.outrasDoencas.praticasIntegrativasId = null

            this.model.atencaoDomiciliar.acamadoId = null
            this.model.atencaoDomiciliar.domiciliadoId = null

            const filter = {
                ...this.getFilter(),
                fields_to_load: [
                    'drogas',
                    'tea',
                    'avc',
                    'infarto',
                    'cancer',
                    'fibromialgia',
                    'internacao',
                    'doenca_cardiaca',
                    'doenca_renal',
                    'doenca_respiratoria',
                    'tratamento_psicologico',
                    'plantas_medicinais',
                    'praticas_integrativas',
                    'acamado',
                    'domiciliado'
                ]
            }

            this.repositories.relatorioEstatisticoPacienteCadastrado.list(filter)
                .then(({ data }) => {
                    this.form.condicionalidades.drogas = this.clone(data.form.condicionalidades.drogas);
                    this.form.condicionalidades.tea = this.clone(data.form.condicionalidades.tea);
                    this.form.outrasDoencas = this.clone(data.form.outrasDoencas);
                    this.form.atencaoDomiciliar = this.clone(data.form.atencaoDomiciliar);
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        changeCondicionalidadesDrogas() {
            this.setLoading()
            this.items = []

            this.model.condicionalidades.teaId = null

            this.model.outrasDoencas.avcId = null
            this.model.outrasDoencas.infartoId = null
            this.model.outrasDoencas.cancerId = null
            this.model.outrasDoencas.fibromialgiaId = null
            this.model.outrasDoencas.internacaoId = null
            this.model.outrasDoencas.doencaCardiacaId = null
            this.model.outrasDoencas.doencaRenalId = null
            this.model.outrasDoencas.doencaRespiratoriaId = null
            this.model.outrasDoencas.tratamentoPsicologicoId = null
            this.model.outrasDoencas.plantasMedicinaisId = null
            this.model.outrasDoencas.praticasIntegrativasId = null

            this.model.atencaoDomiciliar.acamadoId = null
            this.model.atencaoDomiciliar.domiciliadoId = null

            const filter = {
                ...this.getFilter(),
                fields_to_load: [
                    'tea',
                    'avc',
                    'infarto',
                    'cancer',
                    'fibromialgia',
                    'internacao',
                    'doenca_cardiaca',
                    'doenca_renal',
                    'doenca_respiratoria',
                    'tratamento_psicologico',
                    'plantas_medicinais',
                    'praticas_integrativas',
                    'acamado',
                    'domiciliado'
                ]
            }

            this.repositories.relatorioEstatisticoPacienteCadastrado.list(filter)
                .then(({ data }) => {
                    this.form.condicionalidades.tea = this.clone(data.form.condicionalidades.tea);
                    this.form.outrasDoencas = this.clone(data.form.outrasDoencas);
                    this.form.atencaoDomiciliar = this.clone(data.form.atencaoDomiciliar);
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        changeCondicionalidadesTea() {
            this.setLoading()
            this.items = []

            this.model.outrasDoencas.avcId = null
            this.model.outrasDoencas.infartoId = null
            this.model.outrasDoencas.cancerId = null
            this.model.outrasDoencas.fibromialgiaId = null
            this.model.outrasDoencas.internacaoId = null
            this.model.outrasDoencas.doencaCardiacaId = null
            this.model.outrasDoencas.doencaRenalId = null
            this.model.outrasDoencas.doencaRespiratoriaId = null
            this.model.outrasDoencas.tratamentoPsicologicoId = null
            this.model.outrasDoencas.plantasMedicinaisId = null
            this.model.outrasDoencas.praticasIntegrativasId = null

            this.model.atencaoDomiciliar.acamadoId = null
            this.model.atencaoDomiciliar.domiciliadoId = null

            const filter = {
                ...this.getFilter(),
                fields_to_load: [
                    'avc',
                    'infarto',
                    'cancer',
                    'fibromialgia',
                    'internacao',
                    'doenca_cardiaca',
                    'doenca_renal',
                    'doenca_respiratoria',
                    'tratamento_psicologico',
                    'plantas_medicinais',
                    'praticas_integrativas',
                    'acamado',
                    'domiciliado'
                ]
            }

            this.repositories.relatorioEstatisticoPacienteCadastrado.list(filter)
                .then(({ data }) => {
                    this.form.outrasDoencas = this.clone(data.form.outrasDoencas);
                    this.form.atencaoDomiciliar = this.clone(data.form.atencaoDomiciliar);
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        changeOutrasDoencasAvc() {
            this.setLoading()
            this.items = []

            this.model.outrasDoencas.infartoId = null
            this.model.outrasDoencas.cancerId = null
            this.model.outrasDoencas.fibromialgiaId = null
            this.model.outrasDoencas.internacaoId = null
            this.model.outrasDoencas.doencaCardiacaId = null
            this.model.outrasDoencas.doencaRenalId = null
            this.model.outrasDoencas.doencaRespiratoriaId = null
            this.model.outrasDoencas.tratamentoPsicologicoId = null
            this.model.outrasDoencas.plantasMedicinaisId = null
            this.model.outrasDoencas.praticasIntegrativasId = null

            this.model.atencaoDomiciliar.acamadoId = null
            this.model.atencaoDomiciliar.domiciliadoId = null

            const filter = {
                ...this.getFilter(),
                fields_to_load: [
                    'infarto',
                    'cancer',
                    'fibromialgia',
                    'internacao',
                    'doenca_cardiaca',
                    'doenca_renal',
                    'doenca_respiratoria',
                    'tratamento_psicologico',
                    'plantas_medicinais',
                    'praticas_integrativas',
                    'acamado',
                    'domiciliado'
                ]
            }

            this.repositories.relatorioEstatisticoPacienteCadastrado.list(filter)
                .then(({ data }) => {
                    this.form.outrasDoencas.infarto = this.clone(data.form.outrasDoencas.infarto);
                    this.form.outrasDoencas.cancer = this.clone(data.form.outrasDoencas.cancer);
                    this.form.outrasDoencas.fibromialgia = this.clone(data.form.outrasDoencas.fibromialgia);
                    this.form.outrasDoencas.internacao = this.clone(data.form.outrasDoencas.internacao);
                    this.form.outrasDoencas.doencaCardiaca = this.clone(data.form.outrasDoencas.doencaCardiaca);
                    this.form.outrasDoencas.doencaRenal = this.clone(data.form.outrasDoencas.doencaRenal);
                    this.form.outrasDoencas.doencaRespiratoria = this.clone(data.form.outrasDoencas.doencaRespiratoria);
                    this.form.outrasDoencas.tratamentoPsicologico = this.clone(data.form.outrasDoencas.tratamentoPsicologico);
                    this.form.outrasDoencas.plantasMedicinais = this.clone(data.form.outrasDoencas.plantasMedicinais);
                    this.form.outrasDoencas.praticasIntegrativas = this.clone(data.form.outrasDoencas.praticasIntegrativas);
                    this.form.atencaoDomiciliar = this.clone(data.form.atencaoDomiciliar);
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        changeOutrasDoencasInfarto() {
            this.setLoading()
            this.items = []

            this.model.outrasDoencas.cancerId = null
            this.model.outrasDoencas.fibromialgiaId = null
            this.model.outrasDoencas.internacaoId = null
            this.model.outrasDoencas.doencaCardiacaId = null
            this.model.outrasDoencas.doencaRenalId = null
            this.model.outrasDoencas.doencaRespiratoriaId = null
            this.model.outrasDoencas.tratamentoPsicologicoId = null
            this.model.outrasDoencas.plantasMedicinaisId = null
            this.model.outrasDoencas.praticasIntegrativasId = null

            this.model.atencaoDomiciliar.acamadoId = null
            this.model.atencaoDomiciliar.domiciliadoId = null

            const filter = {
                ...this.getFilter(),
                fields_to_load: [
                    'cancer',
                    'fibromialgia',
                    'internacao',
                    'doenca_cardiaca',
                    'doenca_renal',
                    'doenca_respiratoria',
                    'tratamento_psicologico',
                    'plantas_medicinais',
                    'praticas_integrativas',
                    'acamado',
                    'domiciliado'
                ]
            }

            this.repositories.relatorioEstatisticoPacienteCadastrado.list(filter)
                .then(({ data }) => {
                    this.form.outrasDoencas.cancer = this.clone(data.form.outrasDoencas.cancer);
                    this.form.outrasDoencas.fibromialgia = this.clone(data.form.outrasDoencas.fibromialgia);
                    this.form.outrasDoencas.internacao = this.clone(data.form.outrasDoencas.internacao);
                    this.form.outrasDoencas.doencaCardiaca = this.clone(data.form.outrasDoencas.doencaCardiaca);
                    this.form.outrasDoencas.doencaRenal = this.clone(data.form.outrasDoencas.doencaRenal);
                    this.form.outrasDoencas.doencaRespiratoria = this.clone(data.form.outrasDoencas.doencaRespiratoria);
                    this.form.outrasDoencas.tratamentoPsicologico = this.clone(data.form.outrasDoencas.tratamentoPsicologico);
                    this.form.outrasDoencas.plantasMedicinais = this.clone(data.form.outrasDoencas.plantasMedicinais);
                    this.form.outrasDoencas.praticasIntegrativas = this.clone(data.form.outrasDoencas.praticasIntegrativas);
                    this.form.atencaoDomiciliar = this.clone(data.form.atencaoDomiciliar);
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        changeOutrasDoencasCancer() {
            this.setLoading()
            this.items = []

            this.model.outrasDoencas.fibromialgiaId = null
            this.model.outrasDoencas.internacaoId = null
            this.model.outrasDoencas.doencaCardiacaId = null
            this.model.outrasDoencas.doencaRenalId = null
            this.model.outrasDoencas.doencaRespiratoriaId = null
            this.model.outrasDoencas.tratamentoPsicologicoId = null
            this.model.outrasDoencas.plantasMedicinaisId = null
            this.model.outrasDoencas.praticasIntegrativasId = null

            this.model.atencaoDomiciliar.acamadoId = null
            this.model.atencaoDomiciliar.domiciliadoId = null

            const filter = {
                ...this.getFilter(),
                fields_to_load: [
                    'fibromialgia',
                    'internacao',
                    'doenca_cardiaca',
                    'doenca_renal',
                    'doenca_respiratoria',
                    'tratamento_psicologico',
                    'plantas_medicinais',
                    'praticas_integrativas',
                    'acamado',
                    'domiciliado'
                ]
            }

            this.repositories.relatorioEstatisticoPacienteCadastrado.list(filter)
                .then(({ data }) => {
                    this.form.outrasDoencas.fibromialgia = this.clone(data.form.outrasDoencas.fibromialgia);
                    this.form.outrasDoencas.internacao = this.clone(data.form.outrasDoencas.internacao);
                    this.form.outrasDoencas.doencaCardiaca = this.clone(data.form.outrasDoencas.doencaCardiaca);
                    this.form.outrasDoencas.doencaRenal = this.clone(data.form.outrasDoencas.doencaRenal);
                    this.form.outrasDoencas.doencaRespiratoria = this.clone(data.form.outrasDoencas.doencaRespiratoria);
                    this.form.outrasDoencas.tratamentoPsicologico = this.clone(data.form.outrasDoencas.tratamentoPsicologico);
                    this.form.outrasDoencas.plantasMedicinais = this.clone(data.form.outrasDoencas.plantasMedicinais);
                    this.form.outrasDoencas.praticasIntegrativas = this.clone(data.form.outrasDoencas.praticasIntegrativas);
                    this.form.atencaoDomiciliar = this.clone(data.form.atencaoDomiciliar);
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        changeOutrasDoencasFibromialgia() {
            this.setLoading()
            this.items = []

            this.model.outrasDoencas.internacaoId = null
            this.model.outrasDoencas.doencaCardiacaId = null
            this.model.outrasDoencas.doencaRenalId = null
            this.model.outrasDoencas.doencaRespiratoriaId = null
            this.model.outrasDoencas.tratamentoPsicologicoId = null
            this.model.outrasDoencas.plantasMedicinaisId = null
            this.model.outrasDoencas.praticasIntegrativasId = null

            this.model.atencaoDomiciliar.acamadoId = null
            this.model.atencaoDomiciliar.domiciliadoId = null

            const filter = {
                ...this.getFilter(),
                fields_to_load: [
                    'internacao',
                    'doenca_cardiaca',
                    'doenca_renal',
                    'doenca_respiratoria',
                    'tratamento_psicologico',
                    'plantas_medicinais',
                    'praticas_integrativas',
                    'acamado',
                    'domiciliado'
                ]
            }

            this.repositories.relatorioEstatisticoPacienteCadastrado.list(filter)
                .then(({ data }) => {
                    this.form.outrasDoencas.internacao = this.clone(data.form.outrasDoencas.internacao);
                    this.form.outrasDoencas.doencaCardiaca = this.clone(data.form.outrasDoencas.doencaCardiaca);
                    this.form.outrasDoencas.doencaRenal = this.clone(data.form.outrasDoencas.doencaRenal);
                    this.form.outrasDoencas.doencaRespiratoria = this.clone(data.form.outrasDoencas.doencaRespiratoria);
                    this.form.outrasDoencas.tratamentoPsicologico = this.clone(data.form.outrasDoencas.tratamentoPsicologico);
                    this.form.outrasDoencas.plantasMedicinais = this.clone(data.form.outrasDoencas.plantasMedicinais);
                    this.form.outrasDoencas.praticasIntegrativas = this.clone(data.form.outrasDoencas.praticasIntegrativas);
                    this.form.atencaoDomiciliar = this.clone(data.form.atencaoDomiciliar);
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        changeOutrasDoencasInternacao() {
            this.setLoading()
            this.items = []

            this.model.outrasDoencas.doencaCardiacaId = null
            this.model.outrasDoencas.doencaRenalId = null
            this.model.outrasDoencas.doencaRespiratoriaId = null
            this.model.outrasDoencas.tratamentoPsicologicoId = null
            this.model.outrasDoencas.plantasMedicinaisId = null
            this.model.outrasDoencas.praticasIntegrativasId = null

            this.model.atencaoDomiciliar.acamadoId = null
            this.model.atencaoDomiciliar.domiciliadoId = null

            const filter = {
                ...this.getFilter(),
                fields_to_load: [
                    'doenca_cardiaca',
                    'doenca_renal',
                    'doenca_respiratoria',
                    'tratamento_psicologico',
                    'plantas_medicinais',
                    'praticas_integrativas',
                    'acamado',
                    'domiciliado'
                ]
            }

            this.repositories.relatorioEstatisticoPacienteCadastrado.list(filter)
                .then(({ data }) => {
                    this.form.outrasDoencas.doencaCardiaca = this.clone(data.form.outrasDoencas.doencaCardiaca);
                    this.form.outrasDoencas.doencaRenal = this.clone(data.form.outrasDoencas.doencaRenal);
                    this.form.outrasDoencas.doencaRespiratoria = this.clone(data.form.outrasDoencas.doencaRespiratoria);
                    this.form.outrasDoencas.tratamentoPsicologico = this.clone(data.form.outrasDoencas.tratamentoPsicologico);
                    this.form.outrasDoencas.plantasMedicinais = this.clone(data.form.outrasDoencas.plantasMedicinais);
                    this.form.outrasDoencas.praticasIntegrativas = this.clone(data.form.outrasDoencas.praticasIntegrativas);
                    this.form.atencaoDomiciliar = this.clone(data.form.atencaoDomiciliar);
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        changeOutrasDoencasDoencaCardiaca() {
            this.setLoading()
            this.items = []

            this.model.outrasDoencas.doencaRenalId = null
            this.model.outrasDoencas.doencaRespiratoriaId = null
            this.model.outrasDoencas.tratamentoPsicologicoId = null
            this.model.outrasDoencas.plantasMedicinaisId = null
            this.model.outrasDoencas.praticasIntegrativasId = null

            this.model.atencaoDomiciliar.acamadoId = null
            this.model.atencaoDomiciliar.domiciliadoId = null

            const filter = {
                ...this.getFilter(),
                fields_to_load: [
                    'doenca_renal',
                    'doenca_respiratoria',
                    'tratamento_psicologico',
                    'plantas_medicinais',
                    'praticas_integrativas',
                    'acamado',
                    'domiciliado'
                ]
            }

            this.repositories.relatorioEstatisticoPacienteCadastrado.list(filter)
                .then(({ data }) => {
                    this.form.outrasDoencas.doencaRenal = this.clone(data.form.outrasDoencas.doencaRenal);
                    this.form.outrasDoencas.doencaRespiratoria = this.clone(data.form.outrasDoencas.doencaRespiratoria);
                    this.form.outrasDoencas.tratamentoPsicologico = this.clone(data.form.outrasDoencas.tratamentoPsicologico);
                    this.form.outrasDoencas.plantasMedicinais = this.clone(data.form.outrasDoencas.plantasMedicinais);
                    this.form.outrasDoencas.praticasIntegrativas = this.clone(data.form.outrasDoencas.praticasIntegrativas);
                    this.form.atencaoDomiciliar = this.clone(data.form.atencaoDomiciliar);
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        changeOutrasDoencasDoencaRenal() {
            this.setLoading()
            this.items = []

            this.model.outrasDoencas.doencaRespiratoriaId = null
            this.model.outrasDoencas.tratamentoPsicologicoId = null
            this.model.outrasDoencas.plantasMedicinaisId = null
            this.model.outrasDoencas.praticasIntegrativasId = null

            this.model.atencaoDomiciliar.acamadoId = null
            this.model.atencaoDomiciliar.domiciliadoId = null

            const filter = {
                ...this.getFilter(),
                fields_to_load: [
                    'doenca_respiratoria',
                    'tratamento_psicologico',
                    'plantas_medicinais',
                    'praticas_integrativas',
                    'acamado',
                    'domiciliado'
                ]
            }

            this.repositories.relatorioEstatisticoPacienteCadastrado.list(filter)
                .then(({ data }) => {
                    this.form.outrasDoencas.doencaRespiratoria = this.clone(data.form.outrasDoencas.doencaRespiratoria);
                    this.form.outrasDoencas.tratamentoPsicologico = this.clone(data.form.outrasDoencas.tratamentoPsicologico);
                    this.form.outrasDoencas.plantasMedicinais = this.clone(data.form.outrasDoencas.plantasMedicinais);
                    this.form.outrasDoencas.praticasIntegrativas = this.clone(data.form.outrasDoencas.praticasIntegrativas);
                    this.form.atencaoDomiciliar = this.clone(data.form.atencaoDomiciliar);
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        changeOutrasDoencasDoencaRespiratoria() {
            this.setLoading()
            this.items = []

            this.model.outrasDoencas.tratamentoPsicologicoId = null
            this.model.outrasDoencas.plantasMedicinaisId = null
            this.model.outrasDoencas.praticasIntegrativasId = null

            this.model.atencaoDomiciliar.acamadoId = null
            this.model.atencaoDomiciliar.domiciliadoId = null

            const filter = {
                ...this.getFilter(),
                fields_to_load: [
                    'tratamento_psicologico',
                    'plantas_medicinais',
                    'praticas_integrativas',
                    'acamado',
                    'domiciliado'
                ]
            }

            this.repositories.relatorioEstatisticoPacienteCadastrado.list(filter)
                .then(({ data }) => {
                    this.form.outrasDoencas.tratamentoPsicologico = this.clone(data.form.outrasDoencas.tratamentoPsicologico);
                    this.form.outrasDoencas.plantasMedicinais = this.clone(data.form.outrasDoencas.plantasMedicinais);
                    this.form.outrasDoencas.praticasIntegrativas = this.clone(data.form.outrasDoencas.praticasIntegrativas);
                    this.form.atencaoDomiciliar = this.clone(data.form.atencaoDomiciliar);
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        changeOutrasDoencasTratamentoPsicologico() {
            this.setLoading()
            this.items = []

            this.model.outrasDoencas.plantasMedicinaisId = null
            this.model.outrasDoencas.praticasIntegrativasId = null

            this.model.atencaoDomiciliar.acamadoId = null
            this.model.atencaoDomiciliar.domiciliadoId = null

            const filter = {
                ...this.getFilter(),
                fields_to_load: [
                    'plantas_medicinais',
                    'praticas_integrativas',
                    'acamado',
                    'domiciliado'
                ]
            }

            this.repositories.relatorioEstatisticoPacienteCadastrado.list(filter)
                .then(({ data }) => {
                    this.form.outrasDoencas.plantasMedicinais = this.clone(data.form.outrasDoencas.plantasMedicinais);
                    this.form.outrasDoencas.praticasIntegrativas = this.clone(data.form.outrasDoencas.praticasIntegrativas);
                    this.form.atencaoDomiciliar = this.clone(data.form.atencaoDomiciliar);
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        changeOutrasDoencasPlantasMedicinais() {
            this.setLoading()
            this.items = []

            this.model.outrasDoencas.praticasIntegrativasId = null

            this.model.atencaoDomiciliar.acamadoId = null
            this.model.atencaoDomiciliar.domiciliadoId = null

            const filter = {
                ...this.getFilter(),
                fields_to_load: [
                    'praticas_integrativas',
                    'acamado',
                    'domiciliado'
                ]
            }

            this.repositories.relatorioEstatisticoPacienteCadastrado.list(filter)
                .then(({ data }) => {
                    this.form.outrasDoencas.praticasIntegrativas = this.clone(data.form.outrasDoencas.praticasIntegrativas);
                    this.form.atencaoDomiciliar = this.clone(data.form.atencaoDomiciliar);
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        changeOutrasDoencasPraticasIntegrativas() {
            this.setLoading()
            this.items = []

            this.model.atencaoDomiciliar.acamadoId = null
            this.model.atencaoDomiciliar.domiciliadoId = null

            const filter = {
                ...this.getFilter(),
                fields_to_load: [
                    'acamado',
                    'domiciliado'
                ]
            }

            this.repositories.relatorioEstatisticoPacienteCadastrado.list(filter)
                .then(({ data }) => {
                    this.form.atencaoDomiciliar = this.clone(data.form.atencaoDomiciliar);
                })
                .catch(this.handleError)
                .finally(this.unsetLoading())
        },
        changeAtencaoDomiciliarAcamado() {
            this.setLoading()
            this.items = []

            this.model.atencaoDomiciliar.domiciliadoId = null

            const filter = {
                ...this.getFilter(),
                fields_to_load: [
                    'domiciliado'
                ]
            }

            this.repositories.relatorioEstatisticoPacienteCadastrado.list(filter)
                .then(({ data }) => {
                    this.form.atencaoDomiciliar.domiciliado = this.clone(data.form.atencaoDomiciliar.domiciliado);
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        getFilter() {
            const filter = this.clone(this.model)
            return this.camelObjectKeysToSnakeRecursive(filter)
        },
        search() {
            this.$refs.form.validate()
                .then(valid => {
                    if (!valid) return

                        this.setLoading()

                        this.repositories.relatorioEstatisticoPacienteCadastrado.index(this.prepareData())
                            .then(({ data }) => {
                                this.items = data.relatorio
                                this.totalPacientes = data.totalPacientes
                                this.totalPacientesPorSexo = data.totalPacientesPorSexo
                                this.totalFamilias = data.totalFamilias
                                this.totalPacientesPorArea = data.totalPacientesPorArea
                                this.totalPacientesPorMicroArea = data.totalPacientesPorMicroArea
                            })
                            .catch(this.handleError)
                            .finally(() => this.unsetLoading())
                    })
        },
        prepareData() {
            let data = this.clone(this.model)
            const areaEquipeIds = this.form.areaEquipe
                .map(a => Number(a.id))
                .filter(id => Number.isInteger(id));
            const microAreaIds = this.form.microArea
                .map(a => a.id)
                .filter(id => id !== null && id !== undefined && id !== '');
            data.areaEquipeId = this.model.areaEquipeId == null ? areaEquipeIds : this.model.areaEquipeId;
            data.microAreaId = this.model.microAreaId == null ? microAreaIds : this.model.microAreaId;
            return this.camelObjectKeysToSnakeRecursive(data);
        },
        clear() {
            this.model = this.clone(this.initialModel)
            this.model.paciente = null
        },
        print() {
            this.$refs.form.validate()
                .then(valid => {
                    if (!valid) return

                    this.setLoading()

                    this.repositories.impressao.relatorioEstatisticoPacienteCadastrado(this.camelObjectKeysToSnakeRecursive(this.getRequest()))
                        .then(({ data, headers }) => this.openFile(data, headers['content-type']))
                        .finally(() => this.unsetLoading())
                })
        },
        exportTo() {
            this.$refs.form.validate()
                .then(valid => {
                    if (!valid) return

                    this.setLoading()

                    this.repositories.exportacao.relatorioEstatisticoPacienteCadastrado(this.camelObjectKeysToSnakeRecursive(this.getRequest()))
                        .then(({ data, headers }) => this.openFile(data, headers['content-type']))
                        .catch(this.handleError)
                        .finally(() => this.unsetLoading())
                })
        },
        getRequest() {
            let request = {
                ...this.clone(this.model),
                unidadeLabel: this.form.unidadeEquipe.find(unidade => unidade.id === this.model.unidadeEquipeId).nomeFantasia,
                localAtendimentoLabel: this.form.infraestruturaEquipe.find(localAtendimento => localAtendimento.id === this.model.infraestruturaEquipeId).nome,
                localDomicilioLabel: this.model.localDomicilioId == null ? 'Todos' : this.model.localDomicilioId == 1 ? 'Dentro de área' : 'Fora de área',
                areaEquipeLabel: this.model.areaEquipeId == null ? 'Todos' : this.form.areaEquipe.find(area => area.id === this.model.areaEquipeId).nome,
                microAreaLabel: this.model.microAreaId == null ? 'Todos' : this.form.microArea.find(microArea => microArea.id === this.model.microAreaId).nome,
                profissionalLabel: this.model.profissionalId == null ? 'Todos' : this.form.profissional.find(profissional => profissional.id === this.model.profissionalId).nome,
                classificacaoPacienteLabel: this.model.classificacaoPacienteId == null ? 'Todos' : this.form.classificacaoPaciente.find(classificacaoPaciente => classificacaoPaciente.id === this.model.classificacaoPacienteId).nome,
                anosDeLabel: this.model.idade.anosDe == null ? 'Todos' : this.model.idade.anosDe,
                mesesDeLabel: this.model.idade.mesesDe == null ? 'Todos' : this.model.idade.mesesDe,
                diasDeLabel: this.model.idade.diasDe == null ? 'Todos' : this.model.idade.diasDe,
                anosAteLabel: this.model.idade.anosAte == null ? 'Todos' : this.model.idade.anosAte,
                mesesAteLabel: this.model.idade.mesesAte == null ? 'Todos' : this.model.idade.mesesAte,
                diasAteLabel: this.model.idade.diasAte == null ? 'Todos' : this.model.idade.diasAte,
                pacienteLabel: this.model.paciente == null ? 'Todos' : this.model.paciente?.nome,
                condicionalidadesLabel: {
                    sexoLabel: this.model.condicionalidades.sexoId == null ? 'Todos' : this.form.condicionalidades.sexo.find(sexo => sexo.id === this.model.condicionalidades.sexoId).nome,
                    pesoLabel: this.model.condicionalidades.pesoId == null ? 'Todos' : this.form.condicionalidades.peso.find(peso => peso.id === this.model.condicionalidades.pesoId).nome,
                    gestanteLabel: this.model.condicionalidades.gestanteId == null ? 'Todos' : this.model.condicionalidades.gestanteId == 1 ? 'Sim' : 'Não',
                    hipertensoLabel: this.model.condicionalidades.hipertensoId == null ? 'Todos' : this.model.condicionalidades.hipertensoId == 1 ? 'Sim' : 'Não',
                    diabeticoLabel: this.model.condicionalidades.diabeticoId == null ? 'Todos' : this.model.condicionalidades.diabeticoId == 1 ? 'Sim' : 'Não',
                    hanseniaseLabel: this.model.condicionalidades.hanseniaseId == null ? 'Todos' : this.model.condicionalidades.hanseniaseId == 1 ? 'Sim' : 'Não',
                    tuberculoseLabel: this.model.condicionalidades.tuberculoseId == null ? 'Todos' : this.model.condicionalidades.tuberculoseId == 1 ? 'Sim' : 'Não',
                    fumanteLabel: this.model.condicionalidades.fumanteId == null ? 'Todos' : this.model.condicionalidades.fumanteId == 1 ? 'Sim' : 'Não',
                    alcoolLabel: this.model.condicionalidades.alcoolId == null ? 'Todos' : this.model.condicionalidades.alcoolId == 1 ? 'Sim' : 'Não',
                    drogasLabel: this.model.condicionalidades.drogasId == null ? 'Todos' : this.model.condicionalidades.drogasId == 1 ? 'Sim' : 'Não',
                    teaLabel: this.model.condicionalidades.teaId == null ? 'Todos' : this.model.condicionalidades.teaId == 1 ? 'Sim' : 'Não',
                },
                outrasDoencasLabel: {
                    avcLabel: this.model.outrasDoencas.avcId == null ? 'Todos' : this.model.outrasDoencas.avcId == 1 ? 'Sim' : 'Não',
                    infartoLabel: this.model.outrasDoencas.infartoId == null ? 'Todos' : this.model.outrasDoencas.infartoId == 1 ? 'Sim' : 'Não',
                    cancerLabel: this.model.outrasDoencas.cancerId == null ? 'Todos' : this.model.outrasDoencas.cancerId == 1 ? 'Sim' : 'Não',
                    fibromialgiaLabel: this.model.outrasDoencas.fibromialgiaId == null ? 'Todos' : this.model.outrasDoencas.fibromialgiaId == 1 ? 'Sim' : 'Não',
                    internacaoLabel: this.model.outrasDoencas.internacaoId == null ? 'Todos' : this.model.outrasDoencas.internacaoId == 1 ? 'Sim' : 'Não',
                    doencaCardiacaLabel: this.model.outrasDoencas.doencaCardiacaId == null ? 'Todos' : this.model.outrasDoencas.doencaCardiacaId == 1 ? 'Sim' : 'Não',
                    doencaRenalLabel: this.model.outrasDoencas.doencaRenalId == null ? 'Todos' : this.model.outrasDoencas.doencaRenalId == 1 ? 'Sim' : 'Não',
                    doencaRespiratoriaLabel: this.model.outrasDoencas.doencaRespiratoriaId == null ? 'Todos' : this.model.outrasDoencas.doencaRespiratoriaId == 1 ? 'Sim' : 'Não',
                    tratamentoPsicologicoLabel: this.model.outrasDoencas.tratamentoPsicologicoId == null ? 'Todos' : this.model.outrasDoencas.tratamentoPsicologicoId == 1 ? 'Sim' : 'Não',
                    plantasMedicinaisLabel: this.model.outrasDoencas.plantasMedicinaisId == null ? 'Todos' : this.model.outrasDoencas.plantasMedicinaisId == 1 ? 'Sim' : 'Não',
                    praticasIntegrativasLabel: this.model.outrasDoencas.praticasIntegrativasId == null ? 'Todos' : this.model.outrasDoencas.praticasIntegrativasId == 1 ? 'Sim' : 'Não',
                },
                atencaoDomiciliarLabel: {
                    acamadoLabel: this.model.atencaoDomiciliar.acamadoId == null ? 'Todos' : this.model.atencaoDomiciliar.acamadoId == 1 ? 'Sim' : 'Não',
                    domiciliadoLabel: this.model.atencaoDomiciliar.domiciliadoId == null ? 'Todos' : this.model.atencaoDomiciliar.domiciliadoId == 1 ? 'Sim' : 'Não',
                },
                selectedColumns: this.fields.map(field => ({
                    class: field.class,
                    key: this.camelToSnake(field.key),
                    label: field.label,
                })),
                ...(this.sortBy ? {
                    sort_by: this.sortBy,
                    sort_desc: this.sortDesc
                } : {})
            }

            const areaEquipeIds = this.form.areaEquipe
                .map(a => Number(a.id))
                .filter(id => Number.isInteger(id));

            const microAreaIds = this.form.microArea
                .map(a => a.id)
                .filter(id => id !== null && id !== undefined && id !== '');

            request.areaEquipeId = this.model.areaEquipeId == null ? areaEquipeIds : this.model.areaEquipeId;
            request.microAreaId = this.model.microAreaId == null ? microAreaIds : this.model.microAreaId;

            return this.camelObjectKeysToSnakeRecursive(request)
        },
        onSortChanged(ctx) {
            this.sortBy = this.camelToSnake(ctx.sortBy)
            this.sortDesc = ctx.sortDesc
        }
    },
    mixins: [ repository, error, data, object, stringCase, formats, file ],
    watch: {
        'model.paciente': {
            immediate: true,
            handler(newVal) {
            this.pacienteLocal = newVal;
            }
        },
        pacienteLocal(newVal) {
            this.$set(this.model, 'paciente', newVal);
        },
        'selectedCols': function (newValue) {

            this.indeterminate = false

            if (newValue.length > 0 && newValue.length != this.cols.length) {

                this.indeterminate = true
            }
        },
    }
}
</script>
